/*
 * Copyright (c) 2013 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of 2013 SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name:	Global.js
 *
 * Description:	Global JS code required throughout the application.
 *
 */

/*
 *  - - - G L O B A L   V A R I A B L E S - - -
 */

var g_szCurrLoadedModule = "";						// The Name of the currently loaded module.
var g_iCurrLockingLevel = 0;						// Integer to represent which level of locking we are at (for various layered pop-ups).
var g_iCurrentPlatform = 0;							// The platform the user is currently running.
var g_szCurrentPlatformName = "";					// The name of the platform the user is currently running.
var g_szBrowserName = "";							// The Browser the User is currently running.
var g_szBrowserVersion = "";     					// The Browser Version the User is currently running.
var g_bPasswordConfirm_Cancelled = false;			// Flag to indicate if a security confirmation was cancelled.
var g_iClientWidth = getClientWidth();				// Hold the clients width to help detect size changes.
var g_iClientHeight = getClientHeight();			// Hold the clients height to help detect size changes.
var g_szLastClickedElement = "";					// Holds the name of the element we last clicked.
var g_oProcessingButtons = {};						// Holds a collection of icons and their original source. Used to revert icons from the loading image.
var g_iScrollHeightAfterLoad = 0;					// Store the scroll height of the current div.
var g_oProgressBarSF = "";							// The module the progress bar is being used by.
var g_iMaximumTaskDurationInDays = 9999;			// Max duration for a task.

var c_szHighlightClass = "tabSelected";				// The class used to highlight a table row.

// Server time variables.
var g_dtRequestServerTime = null;
var g_dtRequestLocalTime = null;

var g_oSimpleSearch = {
	projectFilter: "",
	skuFilter: "",
	componentFilter: "",
	taskFilter: "",
	projectVisible: true,
	skuVisible: true,
	componentVisible: true,
	taskVisible: true,
	assetVisible: true
};

var g_eProjectFileStatus = {
	Expired: 0,
	Live: 1,
	None: 2
};

var g_eApprovalStatus = {
	Pending: -1,
	Rejected: 0,
	Approved: 1,
	Skipped: 2,
	ConditionallyApproved: 3
};

var g_eGreenlightDocumentStatus = {
	Pending: 0,
	InProcess: 1,
	Processed: 2,
	Failed: 3
};

var g_eApprovalMultiContactRequiredBy = {
	OneContact: 1,
	AllContacts: 2
};

var g_eMetadataFieldType = {
	Text: 1,
	MultiText: 2,
	Select: 3,
	Check: 4,
	Date: 5,
	SectionHeader: 6,
	Barcode: 7,
	MultiSelectList: 8,
	Calculation: 9,
	RichText: 10
}

var g_eValidationType = {
	None: 0,
	AlphaNumberic: 1,
	Integer: 2,
	Decimal: 3,
	Cost: 4,
	Date: 5,
	Hexadecimal: 6,
	NonNumeric: 7,
	Barcode: 8,
	Email: 9,
	RichText: 10
}

/*
 *  - - - E V E N T S - - -
 */

/**
 * Document Key-press Event.
 * @param {object} e The event object.
*/
$(document).keypress(function (e) {
	// Reset the Timeout period.
	if (typeof to_Update === "function") {
		to_Update();
	}

	// If the key in question is a-z/A-Z//0-9, or a space, check if any of the contacts controls are open.
	// If not, fall into the switch below.
	// NB: Using event.which instead of event.keyCode, as keyCode varies between browsers.
	// However, which doesn't appear to work for some of the keys below (e.g. ESC), so that will continue using keyCode.
	if (typeof g_oaContactControls !== "undefined" && ((e.which >= 65 && e.which <= 90) || (e.which >= 97 && e.which <= 122) || (e.which >= 48 && e.which <= 57) || (e.which == 32))) {
		for (var i = 0; i < g_oaContactControls.length; i++) {
			if (g_oaContactControls[i].listOpen) {
				cc_selectContactByCharacter(i, String.fromCharCode(e.which).toLowerCase(), true);
				g_bMultiContactKeyboardPressed = true;
				break;
			}
		}
	}

	switch (e.keyCode) {
		case 8: 	// Backspace Key - Prevents the browser back action being called (when not in an editable text area).
			if (e.target.tagName.toLowerCase() != "input" && e.target.tagName.toLowerCase() != "textarea")
				e.preventDefault();
			break;

		case 13:	//Enter Key.
			if (g_bAuthenticationRqd)
				to_reAuthenticate();				// If required, processes to user re-authentication due to timeout.
			else if ($("#txtHomeSearch").is(":focus")) {
				preProcessMeEx("SEARCH");
			}
			else if ($("#txtCompare_Search").is(":focus")) {
				g_oSFTask_FACompareDocuments.preProcessMeEx('SEARCHDOCUMENTCOMPARISON', 0);
			}
			else if ($("#txtInkLibrary_Search").is(":focus") && typeof g_oSFInkLibrary !== "undefined") {
				g_oSFInkLibrary.preProcessMe('GETINKLIST');
			}
			else if ($("#txtPrinterSpecification_Search").is(":focus") && typeof g_oSFPrinterSpecificationsList !== "undefined") {
				g_oSFPrinterSpecificationsList.preProcessMe('GETPRINTERSPECIFICATIONLIST');
			}
			// If we are on the final step of creating a new project, allow the project to be saved
			// Added g_iCurrLockingLevel == 1 to prevent workflow saving when we are accessing the workflow
			// Added $("#frmProjectDetails").is(':visible'), as we do only want to do it on the Project Details screen.
			else if (typeof g_oSFProject != "undefined" && g_szGuiMode == "NEW" && $("#frmProjectDetails").is(':visible') && g_oSFProject.g_szCurrentTab == "TabSKU" && g_iCurrLockingLevel == 1) {
				g_oSFProject.preProcessMe("NEW");
			}
			else if (typeof g_oSFProjectConfig != "undefined" && g_szGuiMode == "NEW" && g_oSFProjectConfig.g_szCurrentTab == "TabWorkflow" && g_iCurrLockingLevel == 1) {
				g_oSFProjectConfig.preProcessMe();	// If we are on the final step of creating a new project, allow the project to be saved
			}
			break;

		case 27: 	// ESC key - Prevents any Ajax Requests from being cancelled.
			e.preventDefault();
			break;

		case 37:	// Left Arrow.
			if (typeof g_oSFProject != "undefined" && g_szGuiMode == "NEW") {
				var szFocusedEelmentType = $(document.activeElement).prop('tagName').toLowerCase();
				if (szFocusedEelmentType != "input" && szFocusedEelmentType != "textarea")
					g_oSFProject.preProcessMeEx("PREVTAB");
			}
			else if (typeof g_oSFProjectConfig != "undefined" && g_szGuiMode == "NEW") {
				var szFocusedEelmentType = $(document.activeElement).prop('tagName').toLowerCase();
				if (szFocusedEelmentType != "input" && szFocusedEelmentType != "textarea")
					g_oSFProjectConfig.preProcessMeEx("PREVTAB");
			}
			break;

		case 39:	// Right Arrow.
			if (typeof g_oSFProject != "undefined" && g_szGuiMode == "NEW") {
				var szFocusedEelmentType = $(document.activeElement).prop('tagName').toLowerCase();
				if (szFocusedEelmentType != "input" && szFocusedEelmentType != "textarea")
					g_oSFProject.preProcessMeEx("NEXTTAB");
			}
			else if (typeof g_oSFProjectConfig != "undefined" && g_szGuiMode == "NEW") {
				var szFocusedEelmentType = $(document.activeElement).prop('tagName').toLowerCase();
				if (szFocusedEelmentType != "input" && szFocusedEelmentType != "textarea")
					g_oSFProjectConfig.preProcessMeEx("NEXTTAB");
			}
			break;
	}
});

/**
 * Performs Mouse Press functions
 * @param {object} e The event object.
*/
$(document).mouseup(function (e) {
	// Reset the Timeout period.
	if (typeof to_Update === "function") {
		to_Update();
	}

	// Hides our Success / Fail / Info bubbles if user has clicked away from them.
	for (var i = 0; i < g_oaActiveBubbles.length; i++) {
		var oBubble = $("#divSpeech" + g_oaActiveBubbles[i].type);
		if (oBubble.has(e.target).length === 0 && oBubble.exists() && oBubble.css('display') != 'none' && $("#tdSpeech" + g_oaActiveBubbles[i].type + "_Close").css('display') != 'none') {
			if (g_oaActiveBubbles[i].onBlur == "") {
				hideBubbles();
			}
			else if (typeof g_oaActiveBubbles[i].onBlur === "function") {
				g_oaActiveBubbles[i].onBlur();
			}
		}
	}

	// If we have our custom contact control displayed hide the contacts if we click away from it.
	if (typeof g_oaContactControls != "undefined" && g_oaContactControls.length > 0) {
		for (var i = 0; i < g_oaContactControls.length; i++) {
			// Check if the list is currently open and if the element that we've clicked on is within our list div, or it is our list div.
			if (g_oaContactControls[i].listOpen && ("txt" + g_oaContactControls[i].fieldId !== e.target.id && "div_ccl" + g_oaContactControls[i].fieldId !== e.target.id && !$("#div_ccl" + g_oaContactControls[i].fieldId)[0].contains(e.target))) {
				g_oaContactControls[i].closeList();

				// If we are in batch edit then we want to check if we need to render revert icon.
				if (typeof (g_oSFP_Metadata) != "undefined" && g_oSFP_Metadata.g_bBatchEdit) {
					g_oSFBatchEdit.revertContactIconCheck(i);
				}
			}
		}
	}

	// If we have any of the a combo control displayed, we can hide this as well when the user clicks away from it.
	if (typeof g_oaComboControls != "undefined" && g_oaComboControls.length > 0) {
		for (var i = 0; i < g_oaComboControls.length; i++) {
			if (g_oaComboControls[i].listOpen && !(e.target.id.indexOf("comboControl_" + i) == 0) && !(e.target.id.indexOf("comboControlImg_" + i) == 0)) {
				comboControl_CloseList(i);
			}
		}
	}

	// If any widget combo control list is currently displayed, it will be hidden when the user clicks outside of it.
	if (typeof g_oSFGrid !== "undefined") {
		// For each widget in the grid.
		for (var i = 0; i < g_oSFGrid.widgets.length; i++) {
			var oWidget = g_oSFGrid.widgets[i];
			var layoutWidgetid = oWidget.LayoutWidgetId;

			if (typeof oWidget !== "undefined" && typeof oWidget.filterControls !== "undefined") {
				// For each filter control in the widget.
				for (var j = 0; j < oWidget.filterControls.length; j++) {
					var ofilter = oWidget.filterControls[j];
					// If the list is open and the user has clicked away from the list, close the list.
					if (ofilter.listOpen && !(e.target.id.indexOf("chkTagOption_" + layoutWidgetid) == 0) &&
						!(e.target.id.indexOf("divComboControlList_" + layoutWidgetid) == 0) &&
						!(e.target.id.indexOf("comboControlImg_" + layoutWidgetid) == 0) &&
						!(e.target.id.indexOf("comboControlWidget_" + layoutWidgetid) == 0)) {
						comboControlWidget_CloseList(j, layoutWidgetid);
					}
				}
			}
		}
	}

	// A fall-back to prevent the image preview from getting stuck.
	if (typeof dp_hidePreview != "undefined") {
		dp_hidePreview();
	}

	// Get the Id of the element that was clicked.
	var oElement = e.target || e.srcElement;
	g_szLastClickedElement = oElement.id;
});

/**
 * Resize the window.
*/
$(window).resize(function () {
	// resize widgets to fit contents.
	clearTimeout(window.resizedFinished);
	window.resizedFinished = setTimeout(function () {
		if (typeof g_oSFGrid !== "undefined") {
			g_oSFGrid.resizeAllWidgets();
		}
	}, 150);

	var iClientWidth = getClientWidth();
	var iClientHeight = getClientHeight();

	// IE8 fires this event when any element on the page is resized,
	// not necessarily the browser resizing, therefore we need to check if the browser has indeed resized.
	if (g_iClientWidth != iClientWidth || g_iClientHeight != iClientHeight) {
		// Close any open TomSelect dropdowns so they don't appear in the wrong position after resize.
		if (typeof g_oGlobalMultiSelects !== "undefined") {
			for (var iTs = 0; iTs < g_oGlobalMultiSelects.length; iTs++) {
				if (g_oGlobalMultiSelects[iTs] && typeof g_oGlobalMultiSelects[iTs].close === "function") {
					g_oGlobalMultiSelects[iTs].close();
				}
			}
		}

		// Reposition the menu bar.
		centerSideMenu();

		// Reposition any active pop-ups.
		for (var i = 0; i < g_oaActivePopUps.length; i++) {
			if (g_oaActivePopUps[i].x > 0) {
				calculateContentPositions(g_oaActivePopUps[i].div, g_oaActivePopUps[i].x, g_oaActivePopUps[i].y, true);
			}
			else {
				calculatePopUpPositions(g_oaActivePopUps[i].div);
			}
		}

		// Reposition any active bubbles.
		for (var i = 0; i < g_oaActiveBubbles.length; i++) {
			calculateBubblePosition(g_oaActiveBubbles[i].type, g_oaActiveBubbles[i].element, g_oaActiveBubbles[i].arrowPos);
		}

		// If we have any active drag and drop zones, we need to recalculate their position
		// as the screen space they occupy will now have changed.
		if (typeof dd_oDropSpots != "undefined") {
			if (dd_oDropSpots != null && dd_oDropSpots.length > 0) {
				dd_recalcPositions();
			}
		}

		// Need to re-calculate the locking div.
		if (g_iCurrLockingLevel > 0) {
			var lockDiv = "#divLockWindow";
			resizeLock(lockDiv);
		}

		// Resize the contents of the tab if required.
		if (typeof g_oSFProject != "undefined") {
			g_oSFProject.resizeTabContents();
		}

		// Re-render the Assets results if they are visible on the homepage.
		// We do this in an async call as if there are a large amount of assets, we don't,
		// want the re-rendering time to block the re-sizing of the window.
		if ($("#tdAssetSearch_Simple_Container_6").exists()) {
			window.setTimeout("g_oSFPortal.renderAssetSimpleSearchResults();", 250);
		}

		// Changes the size of the div to allow horizontal scroll bar to be visible.
		if ($("#divAssetSearch_Explore_Criteria").exists()) {
			window.setTimeout("g_oSFAsset_ExploreSearch.onScreenResize();", 0);
		}

		// Re-render the Import Preview tables.
		if ($("#divTabPreview").exists() && $("#divTabPreview").is(":visible")) {
			window.setTimeout("g_oSFImportPreview.initializeTab();", 500);
		}

		//Re-size the Queued orders lists
		if ($("#divTabQueuedOrders").exists() && $("#divTabQueuedOrders").is(":visible")) {
			window.setTimeout("g_oSFQueuedOrders.initializeTab();", 500);
		}
	}

	// Set the client width and height.
	g_iClientWidth = iClientWidth;
	g_iClientHeight = iClientHeight;

	// Centre the Speech Choice popup.
	centerDisplayDiv('divSpeechChoice');
});

/**
 * Combines tag values into a single tag.
 * @param {any} Tags - Uncombined tags array.
 * @returns {array} - Tag array with single tag.
 */
function getCombinedTag(Tags) {
	if (!Tags || (Array.isArray(Tags) && Tags.length < 2)) {
		return Tags;
	}
	else if (!Array.isArray(Tags)) {
		var tagArray = [];
		tagArray.push(Tags);
		return tagArray;
	}

	var oTag = deepCopyObject(Tags[0]);
	// Add all values into top tag to be returned.
	for (var i = 1; i < Tags.length; i++) {
		for (var j = 0; j < Tags[i].values.length; j++) {
			// If value is not already added, add it.
			if (!oTag.values.some(function (x) { return x.Value === Tags[i].values[j].Value; })) {
				oTag.values.push(Tags[i].values[j]);
			}
		}
	}
	return [oTag];
}

/**
 * Filter the tags list to retrieve only tags that have the same name, valueTypeId, fieldTypeId & level.
 * @param {objectArray} tag - Tag used for filtering.
 * @param {objectArray} fullTagsList - Full Tag list to perform filter on.
 * @returns {objectArray} - Object array of tags.
 */
function getMatchingTags(tag, fullTagsList) {
	return fullTagsList.filter(function (x) {
		return x.name === tag.name
			&& x.valueTypeId === tag.valueTypeId
			&& x.fieldTypeId === tag.fieldTypeId
			&& x.level === tag.level;
	});
}

/**
 * Prevents event bubbling.
 * @param {object} event The event object.
 */
function disableEventPropagation(event) {
	if (event.stopPropagation) {
		event.stopPropagation();
	}
	else if (window.event) {
		window.event.cancelBubble = true;
	}
}

/**
 * Resizes any active pop-ups.
 */
function ResizePopups() {
	// Reposition any active pop-ups.
	for (var i = 0; i < g_oaActivePopUps.length; i++) {
		if (g_oaActivePopUps[i].x > 0) {
			calculateContentPositions(g_oaActivePopUps[i].div, g_oaActivePopUps[i].x, g_oaActivePopUps[i].y, true);
		}
		else {
			calculatePopUpPositions(g_oaActivePopUps[i].div);
		}
	}
}

/*
 *		- - - W I N D O W   L O C K I N G   M E T H O D S - - -
 */

/**
 * Function to lock the document window while things are loading.
 * @returns {bool} Returns true when complete.
 */
function lockWindow() {
	// Remove the background scroll bar.
	hideMainScrollbar(true);

	document.body.style.zoom = 1;

	var lockDiv = "#divLockWindow";
	if ($(lockDiv).exists()) {
		$(lockDiv).css("z-index", 1000 + (10 * g_iCurrLockingLevel) + 1);
		hideElement("SELECT");
		resizeLock(lockDiv);
		$(lockDiv).toggle(true);
	}
	return true;
}

/**
 * Function to lock the document window while things are loading.
 * @returns {bool} Returns true when complete.
 */
function invisibleLockWindow() {
	document.body.style.zoom = 1;

	var lockDiv = "#divLockWindow";
	if ($(lockDiv).exists()) {
		var invisDiv = "divInvisibleLockWindow"

		$(lockDiv)
			.clone()
			.css("z-index", 1000 + (10 * g_iCurrLockingLevel) + 1)
			.css("opacity", 0)
			.attr("id", invisDiv)
			.insertAfter($(lockDiv));

		hideElement("SELECT");
		resizeLock("#" + invisDiv);
		$("#" + invisDiv).toggle(true);
	}
}

/**
 * Function to lock the document window while things are loading.
 * @returns {bool} Returns true when complete.
 */
function hideInvisibleLockWindow() {
	$("#divInvisibleLockWindow").remove();
}

/**
 * Puts a lock on the screen over the current pop-ups.
 * @returns {bool} Always returns true
 */
function persistentLockWindow() {
	var lockDiv = "#divPersistentLockWindow";

	if ($(lockDiv).exists()) {
		$(lockDiv).css("z-index", 10000000);
		hideElement("SELECT");
		resizeLock(lockDiv);
		$(lockDiv).toggle(true);
	}
	return true;
}

/**
 * Resizes the locking area.
 */
function resizeLock(lockDiv) {
	//var lockDiv = "#divLockWindow";

	if ($(lockDiv).exists()) {
		$(lockDiv).toggle(false);
		$(lockDiv).css({ 'posTop': '0' });
		$(lockDiv).css({ 'posLeft': '0' });
		var iClientWidth = getClientWidth();
		var iScrollWidth = getScrollWidth();
		var iClientHeight = getClientHeight();
		var iScrollHeight = getScrollHeight();
		if (iClientWidth > iScrollWidth)
			$(lockDiv).css({ 'width': iClientWidth + "px" });
		else
			$(lockDiv).css({ 'width': iScrollWidth + "px" });
		if (iClientHeight > iScrollHeight)
			$(lockDiv).css({ 'height': iClientHeight + "px" });
		else
			$(lockDiv).css({ 'height': iScrollHeight + "px" });

		$(lockDiv).toggle(true);
	}
}

/**
 * Function to unlock the browser window.
 */
function unlockWindow() {
	var unlockDiv = "#divLockWindow";

	if ($(unlockDiv).exists() && g_iCurrLockingLevel <= 0) {
		$(unlockDiv).toggle(false);
		showElement("SELECT");
	}
	else {
		$(unlockDiv).css("z-index", 1000 + (10 * (g_iCurrLockingLevel - 1) + 1));
	}

	//Show the background scrollbar (if pop-ups are gone)
	if (g_iCurrLockingLevel == 0) {
		hideMainScrollbar(false);
	}
}

/**
 * Function to unlock the browser window.
 */
function persistentUnlockWindow() {
	var unlockDiv = "#divPersistentLockWindow";

	if ($(unlockDiv).exists()) {
		$(unlockDiv).toggle(false);
		showElement("SELECT");
	} else {
		$(unlockDiv).css("z-index", 10000000);
	}
}

/**
 * Function to show the loading dialog.
 */
function showLoadDialog() {
	if ($("#spnLoadingDialog")) {
		lockWindow();
		var szHTML = "<table cellspacing='0' cellpadding='0' height='100%' width='100%' border='0'>";
		szHTML += "<tr><td align='center'>";
		szHTML += "<img draggable='false' src='img/icon/" + g_oUserProfile.skinFolder + "/Loading_PopUp24.gif' border='0'>";
		szHTML += "</td></tr>";
		szHTML += "</table>";
		$("#spnLoadingDialog").html(szHTML);
		var iTop = calculateCentralYCoordinate(32);
		var iLeft = calculateCentralXCoordinate(32);
		$("#spnLoadingDialog").css({
			'width': 32 + "px",
			'height': 32 + "px",
			'top': iTop + "px",
			'left': iLeft + "px",
			'z-index': (1002 + (10 * g_iCurrLockingLevel))
		});

		$("#spnLoadingDialog").toggle(true);
	}
}

/**
 * Function to hide the loading dialog.
 */
function hideLoadDialog() {
	if ($("#spnLoadingDialog")) {
		unlockWindow();
		$("#spnLoadingDialog").html("");
		$("#spnLoadingDialog").toggle(false);
	}
}

/**
 * Update the Save icon to disable it.
 * @param {string} iconId HTML id of the img tag of the save icon.
 * @param {string} linkId HTML id of the HTML object that has the save icons on click on.
 */
function disableSaveIcon(iconId, linkId) {
	swapImage(iconId, "img/icon/" + g_oUserProfile.skinFolder + "/media-floppy_grey.svg");
	$("#" + iconId).attr("alt", "");
	$("#" + iconId).attr("title", "");
	$("#" + linkId).attr("onclick", "");
	$("#" + linkId).css("cursor", "default");
}

/**
 * Resets an icon to it's previous source.
 * @param {string} elementId HTML id of the icon element that needs resetting.
 */
function resetIcon(elementId) {
	var oElement = $("#" + elementId);

	if (oElement.exists() && !isNothing(g_oProcessingButtons) && g_oProcessingButtons[elementId] !== undefined) {
		oElement
			.attr("onclick", g_oProcessingButtons[elementId].onclick || "")
			.attr("src", g_oProcessingButtons[elementId].src);
	}
}

/**
 * Switches an icon to an alternate to indicate disabled, storing the original source so that it can be reset later.
 * @param {string} elementId HTML id of the icon to disable.
 * @param {string} disabledIcon Source of the disabled version of the icon.
 */
function setDisabledIcon(elementId, disabledIcon) {
	var oElement = $("#" + elementId);

	if (oElement.exists()) {
		g_oProcessingButtons[elementId] = {
			onclick: oElement.attr("onclick"),
			src: oElement.attr("src")
		};

		oElement
			.attr("onclick", "event.stopPropagation();")
			.attr("src", disabledIcon);
	}
}

/**
 * Switches an icon to a loading icon, and stores the original source so that it can be reset later.
 * @param {string} elementId HTML id of the loading icon.
 * @param {string} loadingSize Size of the new loading icon either 24 or 16.
 */
function setLoadingIcon(elementId, loadingSize) {
	var oElement = $("#" + elementId);

	if (oElement.exists()) {
		g_oProcessingButtons[elementId] = {
			onclick: oElement.attr("onclick"),
			src: oElement.attr("src")
		};

		var szLoadingIcon = "img/icon/" + g_oUserProfile.skinFolder + "/loading24.gif";
		if (!isNothing(loadingSize) && loadingSize == "16")
			szLoadingIcon = "img/icon/" + g_oUserProfile.skinFolder + "/loading16.gif";

		oElement
			.attr("onclick", "event.stopPropagation();")
			.attr("src", szLoadingIcon);
	}
}

/**
 * Switches a save icon to a loading icon whilst we are processing an action.
 * @param {string} elementId HTML id of the save icon to swap to a loading GIF.
 */
function setSaveIconLoading(elementId) {
	swapImage(elementId, "img/icon/" + g_oUserProfile.skinFolder + "/loading24.gif");
}

/**
 * Resets a save icon once we have processed an action.
 * @param {string} elementId HTML id of the save icon to reset.
 */
function resetSaveIcon(elementId) {
	swapImage(elementId, "img/icon/" + g_oUserProfile.skinFolder + "/media-floppy.svg");
}

/**
 * Updates the element to show the loading dialog.
 * @param {string} elementId HTML id of the element to add the inline loading GIF to.
 */
function setInlineLoading(elementId) {
	if ($("#" + elementId).exists())
		$("#" + elementId).html("<img draggable='false' src='img/icon/" + g_oUserProfile.skinFolder + "/loading16.gif' />&nbsp;&nbsp;Loading...");
}

/*
 *		- - - M O D U L E   L O A D I N G   M E T H O D S - - -
 */

var g_oaActivePopUps = new Array();

// Prototype for Active pop up object.
function activePopup(div, name, x, y, closeCallBack) {
	this.div = div;
	this.name = name;
	this.x = x;
	this.y = y;
	this.closeCallBack = closeCallBack;
}

/**
 * Adds an active pop-up to the collection.
 * @param {string} div HTML id of the div that will be the active pop-up.
 * @param {string} name Name of the pop-up.
 * @param {int} x X position of the pop-up.
 * @param {int} y Y position of the pop-up.
 * @param {string} closeCallBack Code to call as the callback.
 */
function addActivePopup(div, name, x, y, closeCallBack) {
	if (isNothing(y))
		y = x;

	if (isNothing(closeCallBack))
		closeCallBack = "";

	var oPopup = new activePopup(div, name, x, y, closeCallBack);

	if (oPopup)
		g_oaActivePopUps.push(oPopup);
}

/**
 * Brings an active pop-up to the front, by closing everything above it.
 * @param {string} name Name of the pop-up.
 * @param {bool} bSuppressCloseCallback True to suppress close callback.
 */
function bringActivePopupToFront(name, bSuppressCloseCallback) {
	var iPopupIndex = -1;

	for (var i = 0; i < g_oaActivePopUps.length; i++) {
		if (g_oaActivePopUps[i].name === name) {
			iPopupIndex = i;
			break;
		}
	}

	if (iPopupIndex >= 0) {
		while (iPopupIndex < g_oaActivePopUps.length - 1) {
			if (bSuppressCloseCallback) {
				g_oaActivePopUps[g_oaActivePopUps.length - 1].closeCallBack = "";
			}
			closePopUp();
		}
	}
}

/**
 * Closes all pop-ups.
 * @param {bool} bSuppressCloseCallback True to suppress the close callback.
 */
function closeAllPopUps(bSuppressCloseCallback) {
	while (g_oaActivePopUps.length > 0) {
		if (bSuppressCloseCallback) {
			g_oaActivePopUps[g_oaActivePopUps.length - 1].closeCallBack = "";
		}
		closePopUp();
	}
}

/**
 * Determines the next pop-up to use (when current = false)
 * or retrieves the current pop-up (current = true).
 * @param {bool} current Retrieves the current pop-up if true otherwise determines the next pop-up.
 * @returns {string} Returns the HTML id of the pop up's content div.
 */
function getContentPopup(current) {
	var divName = "divPopUp";
	var iNextLevel = 1;

	// Get the next level of div we will use.
	if (current)
		iNextLevel = (g_iCurrLockingLevel > 1 ? g_iCurrLockingLevel : 0);
	else
		iNextLevel = (g_iCurrLockingLevel > 0 ? g_iCurrLockingLevel + 1 : 0);

	// Append to the Pop-up Name
	divName += (iNextLevel > 1 ? iNextLevel : "");

	// If the pop-up doesn't exist, create it.
	if (!$("#" + divName).exists())
		injectPopupHTML(iNextLevel);

	// Return the Content div.
	return divName + "_Content";
}

/**
 * Finds an active pop-up by name.
 * @param {string} name Name of the pop-up to find.
 * @returns {string} HTML id of the contents pop-up div.
 */
function getContentPopupByName(name) {
	for (var i = 0; i < g_oaActivePopUps.length; i++) {
		if (g_oaActivePopUps[i].name === name) {
			return "divPopUp" + (i > 0 ? i + 1 : "") + "_Content";
		}
	}
}

/**
 * Removes an active pop-up from the collection.
 */
function removeActivePopup() {
	// Call the Close Callback if valid.
	if (g_oaActivePopUps.length > 0) {
		if (g_oaActivePopUps[g_oaActivePopUps.length - 1].closeCallBack.length > 0)
			eval(g_oaActivePopUps[g_oaActivePopUps.length - 1].closeCallBack);

		// Remove the active pop-up.
		g_oaActivePopUps.pop();
	}
}

/**
 * Loads a module into the pop up window.
 * @param {string} module Name of module to load.
 * @param {string} title Title of module that will be displayed at the top of the pop-up.
 * @param {int} percentX Percentage of the screen the pop-up will take in the x axis. This will be used to calculated the width in px.
 * @param {int} percentY Percentage of the screen the pop-up will take in the y axis. This will be used to calculated the height in px.
 * @param {string=} closeCallback Code that will be executed as the callback.
 */
function loadModule(module, title, percentX, percentY, closeCallback) {
	// Determine the pop-up level we are working with and its properties.
	var divName = "divPopUp";
	if (g_iCurrLockingLevel > 0) {
		divName += (g_iCurrLockingLevel + 1);
		$("#tdPopup" + (g_iCurrLockingLevel + 1) + "Title").text(title);
		$("#tdPopup" + (g_iCurrLockingLevel + 1) + "Title").removeClass();
		$("#tdPopup" + (g_iCurrLockingLevel + 1) + "Title").addClass("popupTitle");
	} else {
		$("#tdPopupTitle").text(title);
		$("#tdPopupTitle").removeClass();
		$("#tdPopupTitle").addClass("popupTitle");
	}
	if (isNothing(percentX))
		percentX = 90;
	if (isNothing(percentY))
		percentY = percentX;

	// Load the window.
	showLoadDialog();
	displayPopupWindow(divName, percentX, percentY);
	g_szCurrLoadedModule = module;
	$('#spnLoadingDialog').toggle(false);
	addActivePopup(divName, title, percentX, percentY, closeCallback);
}

/**
 * Loads a module into the pop up window.
 * Allows a function call to be added after loading the module.
 * @param {string} module Name of module to load.
 * @param {string} title Title of module that will be displayed at the top of the pop-up.
 * @param {int} percentX Percentage of the screen the pop-up will take in the x axis. This will be used to calculated the width in px.
 * @param {int} percentY Percentage of the screen the pop-up will take in the y axis. This will be used to calculated the height in px.
 * @param {string} closeCallback Code that will be executed as the callback.
 * @param {any} func - Function to be called after the module has been loaded.
 */
function loadModuleFunc(module, title, percentX, percentY, closeCallback, func) {
	loadModule(module, title, percentX, percentY, closeCallback);
	func();
}

/**
 * Removes the HTML of a module.
 * @param {string} divName - ID corresponding to the element to remove.
 * @param {string} divNameBack - ID corresponding to the main element's back div.
 */
function removeModule(divName, divNameBack) {
	$("#" + divName).remove();
	$("#" + divNameBack).remove();
}

/**
 * Unloads a module from the pop-up window.
 */
function unloadModule() {
	// Determine the pop-up level we are working with.
	var divName = "divPopUp";
	var divNameBack = "divPopUpBack";
	if (g_iCurrLockingLevel > 1) {
		divName += (g_iCurrLockingLevel).toString();
		divNameBack += (g_iCurrLockingLevel).toString();
		$("#tdPopup" + (g_iCurrLockingLevel) + "Title").text("");
	} else {
		g_szCurrLoadedModule = "";
		$("#tdPopupTitle").text("");
	}

	// Set module vars.
	if (g_iCurrLockingLevel > 0)
		g_iCurrLockingLevel--;

	// Hide the window.
	hidePopupWindow(divName);
	removeActivePopup();

	// Remove the elements after 400ms (this is duration of fade).
	setTimeout(removeModule(divName, divNameBack), 400);

	// Lock the window to prevent a double click on close.
	persistentLockWindow();
}

/**
 * Switches the currently loaded module.
 * @param {string} module Name of the module to switch to.
 * @param {string} title Title of the module to switch to.
 * @param {string} closeCallback Code that will be executed as the callback.
 */
function switchModule(module, title, closeCallback) {
	if (g_iCurrLockingLevel > 0)
		$("#tdPopup" + (g_iCurrLockingLevel + 1) + "Title").text(title);
	else
		$("#tdPopupTitle").text(title);
	g_szCurrLoadedModule = module;
	if (isNothing(closeCallback))
		closeCallback = "";

	if (g_oaActivePopUps.length > 0) {
		g_oaActivePopUps[g_oaActivePopUps.length - 1].name = title;
		g_oaActivePopUps[g_oaActivePopUps.length - 1].closeCallBack = closeCallback;
		calculateContentPositions($("#" + getContentPopup(true)).parents(".popup").attr("id"), g_oaActivePopUps[g_oaActivePopUps.length - 1].percentX, g_oaActivePopUps[g_oaActivePopUps.length - 1].percentY, true);
	}

	unlockWindow();
}

/*
 *		- - - P O P - U P   M E T H O D S - - -
 */

/**
 * Calculate the div position and content sizes (pop-up percentage size specified).
 * @param {string} div HTML id of the div to calculate the positions and content sizes for.
 * @param {int} x Percentage of the screens width this pop-up will take.
 * @param {int} y Percentage of the screens height this pop-up will take.
 * @param {bool} switched If false the z-index will be updated.
 */
function calculateContentPositions(div, x, y, switched) {
	// Calculate the Pop-up positions.
	var idivHeight = (y * getClientHeight()) / 100;
	var idivWidth = (x * getClientWidth()) / 100;

	// override for width if it's too smaller - as a rule we do not allow
	// popups less then 750px! See class 'popup'
	if (idivWidth < 750)
		idivWidth = 750;

	var iTop = calculateCentralYCoordinate(parseInt(idivHeight, 10));
	var iLeft = calculateCentralXCoordinate(parseInt(idivWidth, 10));

	// Round the Pop-up positions to the nearest whole number.
	idivHeight = Math.round(idivHeight);
	idivWidth = Math.round(idivWidth);
	iTop = Math.round(iTop);
	iLeft = Math.round(iLeft);

	// Get the margin size for the header to subtract from the height.
	var iHeaderMargin = 30;

	// If we have a skin folder, check if this needs to be amended for the classic view.
	if (typeof (g_oUserProfile) != "undefined" && g_oUserProfile.skinFolder == "cls") {
		iHeaderMargin = 20;
	}

	// Apply the CSS.
	var oPopup = $("#" + div);
	oPopup.css({
		"height": idivHeight,
		"width": idivWidth,
		"top": iTop,
		"left": iLeft
	});

	if (!switched) {
		oPopup.css("z-index", 1000 + (10 * g_iCurrLockingLevel));
	}

	// Calculate the Pop-up content height and widths (required for scrolling).
	var oPopupContent = $("#" + div + "_Content");
	if (oPopupContent.exists()) {
		var iHeaderHeight = $("#" + div + "_Header").height();

		oPopupContent.css({
			"height": (idivHeight - iHeaderHeight - iHeaderMargin),	// 20px (cls) or 30px (mod) margin space.
			"width": (idivWidth - 15)								// 15px margin space.
		});

		if (oPopup.has("#divPopUpContent_Content") && $("#" + div).has("#divPopUpContent_Header")) {
			var mainHeight = oPopupContent.height();
			var header = oPopupContent.find("#divPopUpContent_Header").height();
			oPopupContent.find("#divPopUpContent_Content").css("height", mainHeight - header - iHeaderMargin);
		}
	}
}

/**
 * Calculates the Pop Ups position (dimensions not specified).
 * @param {string} div HTML id of the div that we are calculating the positions for.
 */
function calculatePopUpPositions(div) {
	var iHeight = $("#" + div).height();
	var iWidth = $("#" + div).width();

	var iTop = calculateCentralYCoordinate(parseInt(iHeight, 10));
	var iLeft = calculateCentralXCoordinate(parseInt(iWidth, 10));

	// Apply the CSS.
	$("#" + div).css("top", iTop);
	$("#" + div).css("left", iLeft);
	$("#" + div).css("z-index", 1000 + (10 * g_iCurrLockingLevel));
}

/**
 * Shows the email form.
 */
function displayEmailForm() {
	var div = "divEmailForm"; 		// Name of the div.
	var x = 60;
	var y = 60;

	// Check the div exists.
	if ($("#" + div).exists()) {
		// Lock window firstly
		lockWindow();
		g_iCurrLockingLevel++;

		// Calculate the div position and content sizes.
		calculateContentPositions("divEmailForm", 60, 60, false);

		// Show the window.
		$("#" + div).fadeIn();
	}
}

/**
 * Hides the email form.
 */
function hideEmailForm() {
	var div = "divEmailForm";

	// Check the div exists.
	if ($("#" + div).exists()) {
		// Hide any bubbles.
		hideBubbles();

		// Hide the pop-up.
		$("#" + div).fadeOut();

		// Clear the text box contents.
		$("#txtEmailFrom").val("");
		$("#txtEmailTo").val("");
		$("#txtEmailSubject").val("");
		$("#txtEmailBody").val("");

		// Hide any error highlighting.
		$("#txtEmailFrom").removeClass();
		$("#txtEmailFrom").addClass("insightTextBox");
		$("#txtEmailTo").removeClass();
		$("#txtEmailTo").addClass("insightTextBox");

		// Hide the Load / Unlock the window.
		if (g_iCurrLockingLevel > 0)
			g_iCurrLockingLevel--;
		hideLoadDialog();
	}
}

/**
 * Dynamically creates a pop-up window within the HTML.
 * @param {int} popupLevel The pop up's level.
 */
function injectPopupHTML(popupLevel) {
	var szlevel = (popupLevel > 1 ? popupLevel : "");

	var szHTML = "";
	// pop-up.
	szHTML += "<div id='divPopUp" + szlevel + "' class='roundBorders_popup popup front smoothReSize' style='display:none;'>";
	szHTML += "<table class='tblPopup' align='center' cellspacing='0' cellpadding='0'>";
	szHTML += "<tr>";
	szHTML += "<td align='center' width='100%'>";
	// Header.
	szHTML += "<div id='divPopUp" + szlevel + "_Header' class='popupHeader'>";
	szHTML += "<table width='100%'>";
	szHTML += "<tr id='tdPopup" + szlevel + "TitleRow'>";
	szHTML += "<td id='tdPopup" + szlevel + "Title' colspan='2' class='popupTitle' valign='top' style='cursor: initial;'>&nbsp;</td>";
	szHTML += "<td id='tdPopup" + szlevel + "ToolBar' align='right' valign='top' style='width:20%'>";
	szHTML += "<a id=\"aHelpIcon\" onClick='loadHelp();' style='cursor:pointer;'><img draggable='false' src='img/icon/" + g_oUserProfile.skinFolder + "/help-browser24.png' align='absmiddle' alt='" + c_szHelpPrompt + "' title='" + c_szHelpPrompt + "' /></a>&nbsp;";
	szHTML += "<a id='aPopup" + szlevel + "_Close' onClick='closePopUp();' style='cursor:pointer;'><img draggable='false' id='imgClose' class='iconNormal' src='img/icon/" + g_oUserProfile.skinFolder + "/emblem-unreadable.svg' align='absmiddle' alt='" + c_szClosePrompt + "' title='" + c_szClosePrompt + "' /></a>";
	szHTML += "</td></tr></table></div>";
	szHTML += "</td></tr>";
	// Content.
	szHTML += "<tr><td>";
	szHTML += "<div id='divPopUp" + szlevel + "_Content' class='popupOuterContent'></div>";
	szHTML += "</td></tr>";
	// Close off pop-up.
	szHTML += "<tr><td>";
	szHTML += "<img draggable='false' src='img/hdr/" + g_oUserProfile.skinFolder + "/shim.gif' height='10px' border='0' />";
	szHTML += "</td></tr></table>";
	szHTML += "</div>";
	szHTML += "<div id='divPopUpBack" + szlevel + "' class='roundBorders_sml popup back' style='display:none;'></div>";
	// Append the HTML.
	$(document.body).append(szHTML);
}

/**
 * Shows the pop-up and locks the window behind.
 * @param {string} div HTML id of the div to display as the pop up window.
 * @param {int} percentX Percentage of the screens width this pop-up will take.
 * @param {int} percentY Percentage of the screens height this pop-up will take.
 */
function displayPopupWindow(div, percentX, percentY) {
	// Check the div exists.
	if ($("#" + div).exists()) {
		// Lock window firstly
		lockWindow();

		g_iCurrLockingLevel++;

		// Calculate the Pop-up position and content sizes.
		calculateContentPositions(div, percentX, percentY, false);

		// Show the window.
		$("#" + div).fadeIn();
	}
}

/**
 * Hides the pop-up and unlocks the window.
 * @param {string} div HTML id of the div to hide.
 */
function hidePopupWindow(div) {
	// Check the div exists.
	if ($("#" + div).exists()) {
		// Hide the pop-up.
		$("#" + div).fadeOut();

		// Allow interaction to resume once fading is complete. 400ms is default duration for fadeOut method.
		setTimeout(persistentUnlockWindow, 500);

		// Hide the Load / Unlock the window.
		hideLoadDialog();

		//Show the background scrollbar (if pop-ups are gone)
		if (g_iCurrLockingLevel == 0) {
			hideMainScrollbar(false);
		}
	}
}

/**
 * Hides/shows the main scrollbar when a pop-up
 * becomes the focus.
 * @param {bool} set scrollbar to f:show/t:hidden.
 */
function hideMainScrollbar(bFlag) {
	if (bFlag) {
		$('body').css('overflow-y', 'hidden');
	}
	else {
		$('body').css('overflow-y', 'scroll');
	}
}

/**
 * Show the Custom Action Pop-Up.
 * @param {string} szNotification- Message which will be displayed.
 */
function displayCustomActionPopup(szNotification) {
	var div = "divCustomAction"; 		// Name of the div.

	// Set Message.
	$('#tdCustomActionMessage').html(szNotification);

	// Check the div exists.
	if ($("#" + div).exists()) {
		lockWindow();
		g_iCurrLockingLevel++;

		// Calculate the central position and update location.
		calculatePopUpPositions(div);
		addActivePopup(div, "SessionExpired", 0, 0, "");

		// Show the window.
		$("#" + div).fadeIn();
	}
}

// Hides the session expired window.
function hideCustomActionPopup() {
	var div = "divCustomAction";

	// Check the div exists.
	if ($("#" + div).exists()) {
		// Hide the pop-up.
		$("#" + div).fadeOut();
		removeActivePopup();

		if (g_iCurrLockingLevel > 0)
			g_iCurrLockingLevel--;
		unlockWindow();
	}

	// Clear Message.
	$('#tdCustomActionMessage').html('');
}

// Shows the password re-entry pop-up.
function displayPasswordReEntry(callback) {
	var div = "divPasswordReEntry"; 		// Name of the div.
	g_bPasswordConfirm_Cancelled = false;	// Set the flag to false.
	gb_setCommand("authorise", callback);

	// Check the div exists.
	if ($("#" + div).exists()) {
		lockWindow();
		g_iCurrLockingLevel++;

		// Clear the text box.
		$("#txtPasswordReEnter").val("");

		// Hide any error highlighting.
		$("#txtPasswordReEnter").removeClass();
		$("#txtPasswordReEnter").addClass("insightTextBoxLrg");

		// Calculate the central position and update location.
		calculatePopUpPositions(div);
		addActivePopup(div, "PasswordReEntry", 0, 0, "");

		// Show the window.
		$("#" + div).fadeIn();
	}
}

/**
 * Centres a div display popup.
 * @param {string} elementId - Id of the element to be centred.
 */
function centerDisplayDiv(elementId) {
	// Check the div exists.
	if ($("#" + elementId).exists()) {
		// Calculate the central position and update location.
		calculatePopUpPositions(elementId);
	}
}

/**
 * Hides the password re-entry window.
 */
function hidePasswordReEntry() {
	var div = "divPasswordReEntry";

	// Check the div exists.
	if ($("#" + div).exists()) {
		// Hide the pop-up.
		$("#" + div).fadeOut();
		removeActivePopup();

		if (g_iCurrLockingLevel > 0)
			g_iCurrLockingLevel--;
		unlockWindow();
	}
}

/**
 * Shows the session expired pop-up.
 */
function displaySessionExpiredPopup() {
	var div = "divSessionExpired"; 		// Name of the div.

	// Check the div exists.
	if ($("#" + div).exists()) {
		lockWindow();
		g_iCurrLockingLevel++;

		// Clear the text box.
		$("#txtReAuthenticate").val("");

		// Hide any error highlighting.
		$("#txtReAuthenticate").removeClass();
		$("#txtReAuthenticate").addClass("insightTextBoxLrg");

		// Calculate the central position and update location.
		calculatePopUpPositions(div);
		addActivePopup(div, "SessionExpired", 0, 0, "");

		// Show the window.
		$("#" + div).fadeIn();
		//Make sure the text box has focus.
		$("#txtReAuthenticate").focus();
	}
}

/**
 * Hides the session expired window.
 */
function hideSessionExpiredPopup() {
	var div = "divSessionExpired";

	// Check the div exists.
	if ($("#" + div).exists()) {
		// Hide the pop-up.
		$("#" + div).fadeOut();
		removeActivePopup();

		if (g_iCurrLockingLevel > 0)
			g_iCurrLockingLevel--;
		unlockWindow();
	}
}

/**
 * Shows the save tab pop-up.
 * @param {string} confirmAction Code to execute as the confirm action.
 * @param {string} declineAction Code to execute as the decline action.
 */
function displaySaveSectionPopup(confirmAction, declineAction) {
	var div = "divSaveSection"; 		// Name of the div.
	gb_setCommand("saveSection_save", "hideSaveSectionPopup();" + confirmAction);
	gb_setCommand("saveSection_continue", "hideSaveSectionPopup();" + declineAction);

	// Check the div exists.
	if ($("#" + div).exists()) {
		lockWindow();
		g_iCurrLockingLevel++;

		// Calculate the central position and update location.
		calculatePopUpPositions(div);
		addActivePopup(div, "SaveSection", 0, 0, "");

		// Show the window.
		$("#" + div).fadeIn();
	}
}

/**
 * Hides the save tab window.
 */
function hideSaveSectionPopup() {
	var div = "divSaveSection";

	// Check the div exists.
	if ($("#" + div).exists()) {
		// Hide the pop-up.
		$("#" + div).fadeOut();
		removeActivePopup();

		if (g_iCurrLockingLevel > 0)
			g_iCurrLockingLevel--;
		unlockWindow();
	}
}

/**
 * Shows the multi save section pop-up.
 * @param {string} confirmAction Code to execute as the confirm action.
 * @param {string} declineAction Code to execute as the decline action.
 */
function displayBatchEditSaveSectionMultiPopup(confirmAction, declineAction) {
	var div = "divBatchEditSaveSectionMulti"; 		// Name of the div.
	gb_setCommand("batchEditSaveSectionMulti_save", confirmAction);
	gb_setCommand("batchEditSaveSectionMulti_continue", declineAction);
	$("#trBatchEditSaveSectionMulti_Options").toggle(true);

	// Check the div exists.
	if ($("#" + div).exists()) {
		lockWindow();
		g_iCurrLockingLevel++;

		// Calculate the central position and update location.
		calculatePopUpPositions(div);
		addActivePopup(div, "BatchEditSaveSectionMulti", 0, 0, "");

		// Show the window.
		$("#" + div).fadeIn();
	}
}

/**
 * Shows the multi save section pop-up.
 * @param {string} confirmAction Code to execute as the confirm action.
 * @param {string} declineAction Code to execute as the decline action.
 */
function displaySaveSectionMultiPopup(confirmAction, declineAction) {
	var div = "divSaveSectionMulti"; 		// Name of the div.
	gb_setCommand("saveSectionMulti_save", confirmAction);
	gb_setCommand("saveSectionMulti_continue", "hideSaveSectionMultiPopup();" + declineAction);
	gb_setCommand("saveSectionMulti_SuccessContinue", "hideSaveSectionMultiPopup();" + declineAction);

	$("#trSaveSectionMulti_Options").toggle(true);
	$("#trSaveSectionMulti_Success").toggle(false);

	// Check the div exists.
	if ($("#" + div).exists()) {
		lockWindow();
		g_iCurrLockingLevel++;

		// Calculate the central position and update location.
		calculatePopUpPositions(div);
		addActivePopup(div, "SaveSectionMulti", 0, 0, "");

		// Show the window.
		$("#" + div).fadeIn();
	}
}

/**
 * Hides the multi save section window.
 */
function hideBatchEditSaveSectionMultiPopup() {
	var div = "divBatchEditSaveSectionMulti";

	// Check the div exists.
	if ($("#" + div).is(":visible")) {
		// Hide the pop-up.
		$("#" + div).fadeOut();
		removeActivePopup();

		if (g_iCurrLockingLevel > 0) {
			g_iCurrLockingLevel--;
		}

		unlockWindow();
	}
}

/**
 * Hides the multi save section window.
 */
function hideSaveSectionMultiPopup() {
	var div = "divSaveSectionMulti";

	// Check the div exists.
	if ($("#" + div).exists()) {
		// Hide the pop-up.
		$("#" + div).fadeOut();
		removeActivePopup();

		if (g_iCurrLockingLevel > 0)
			g_iCurrLockingLevel--;
		unlockWindow();
	}
}

/**
 * Shows the clone confirmation pop-up.
 * @param {string} callback Code to execute as the callback.
 */
function displayCloneConfirmation(callback) {
	var div = "divCloneUnique"; 			// Name of the div.
	g_bPasswordConfirm_Cancelled = false;	// Set the flag to false.
	gb_setCommand("cloneUnique_Continue", callback);

	// Check the div exists.
	if ($("#" + div).exists()) {
		lockWindow();
		g_iCurrLockingLevel++;

		// Clear the text box.
		$("#txtCloneName").val("");
		$("#spnCloneName_Err").toggle(false);

		// Hide any error highlighting.
		$("#txtCloneName").removeClass();
		$("#txtCloneName").addClass("insightTextBoxLrg");

		// Calculate the central position and update location.
		calculatePopUpPositions(div);
		addActivePopup(div, "CloneUnique", 0, 0, "");

		// Show the window.
		$("#" + div).fadeIn();
	}
}

/**
 * Hides the Clone confirmation window.
 */
function hideCloneConfirmation() {
	var div = "divCloneUnique";

	// Check the div exists.
	if ($("#" + div).exists()) {
		// Hide the pop-up.
		$("#" + div).fadeOut();
		removeActivePopup();

		if (g_iCurrLockingLevel > 0)
			g_iCurrLockingLevel--;
		unlockWindow();
	}
}

/**
 * Show the save search pop-up.
 * @param {string} callback Code to execute as the callback.
 */
function displaySaveSearchPopup(callback) {
	var div = "divSaveSearch"; 		// Name of the div.
	gb_setCommand("saveSearch", callback);

	// Check the div exists.
	if ($("#" + div).exists()) {
		lockWindow();
		g_iCurrLockingLevel++;

		// Calculate the central position and update location.
		calculatePopUpPositions(div);
		addActivePopup(div, "SaveSection", 0, 0, "");

		// Show the window.
		$("#" + div).fadeIn();
	}
}

/**
 * Hides the save search pop-up.
 */
function hideSaveSearchPopup() {
	var div = "divSaveSearch";

	// Check the div exists.
	if ($("#" + div).exists()) {
		// Hide the pop-up.
		$("#" + div).fadeOut();
		removeActivePopup();

		if (g_iCurrLockingLevel > 0)
			g_iCurrLockingLevel--;
		unlockWindow();
	}
}

/**
 * Shows the saved search menu.
 */
function toggleSavedSearchMenu() {
	if (!$("#divSavedSearchMenu").is(':animated')) {
		if ($("#divMenuExpand").is(":visible")) {
			$("#divSavedSearchMenu").stop();
			$("#divMenuExpand").toggle(false);
			$("#divSavedSearchMenu").animate({ width: 'toggle' }, 500);
		}
		else {
			$("#divSavedSearchMenu").stop();
			$("#divSavedSearchMenu").animate({ width: 'toggle' }, 500, function complete() { $("#divMenuExpand").toggle(true); });
		}
	}
}

/**
 * Filters the saved search menu
 */
function filterSavedSearchMenu() {
	// Get the elements.
	var oMenu = $("#divSavedSearchMenu");
	var oMenuItems = $("#divSavedSearchMenuItems").find(".fileDetails");
	var szSearchCriteria = trim($("#txtHomeSearch").val());
	var saSearchCriteria = szSearchCriteria.split(" ");

	// If we have saved searches.
	if (oMenuItems.length > 0) {
		// Hide all the Saved Searches.
		oMenuItems.css('display', 'none');

		// For each saved search check its name against the search criteria and display it if there is a match.
		oMenuItems.filter(function () {
			for (var i = 0; i < saSearchCriteria.length; i++) {
				if ($(this).find('.savedSearchTitle').text().toLowerCase().indexOf(saSearchCriteria[i].toLowerCase()) > -1) {
					$(this).css('display', 'block');
					return true;
				} else
					$(this).css('display', 'none');
			}
			return false;
		}).show();
	}
}

/*
 *		- - - S I D E   M E N U   M E T H O D S - - -
 */

/**
 * Center the side menu on the screen.
 */
function centerSideMenu() {
	// Get half the client screen height.
	var iTop = (getClientHeight() / 2);

	// Get the div side menu height.
	var iMenuHeight = $("#divSideMenu").height();
	$("#divSideMenu").css("top", iTop - (iMenuHeight / 2));
}

/**
 * Toggle the side menu tooltips on the modern skin.
 * @param {string} item The name of the item to display the tooltip for.
 * @param {bool} display True to display false to hide.
 */
function toggleSideMenuTooltip(item, display) {
	if (g_oUserProfile.skinFolder == "mod") {
		// Get the item source and align it with the side menu.
		var szItemSource = $("#sideMenu" + item).attr("src");
		$("#divTooltip" + item).css("top", ($("#sideMenu" + item).offset().top - getScrollAmountY()));

		// Update the src of the image and add the animation.
		$("#sideMenu" + item).attr("src", szItemSource.replace((display ? "nav_" : "navalt_"), (display ? "navalt_" : "nav_")));
		$("#divTooltip" + item).stop();
		$("#divTooltip" + item).animate({ width: 'toggle' }, 500);
	}
}

/*
 *		- - - I N F O   B U B B L E S - - -
 */

var g_oaActiveBubbles = new Array();

/**
 * Prototype for Active bubble object.
 * @param {string} type Bubble type.
 * @param {string} element HTML id of the element that the bubble will be attached to.
 * @param {string} arrowPos Arrow position of bubble.
 * @param {object} onBlur OnBlur function.
 */
function activeBubble(type, element, arrowPos, onBlur) {
	this.type = type;
	this.element = element;
	this.arrowPos = arrowPos;
	this.onBlur = onBlur;
}

/**
 * Adds an active bubble to the collection.
 * @param {string} type Bubble type.
 * @param {string} element HTML id of the element that the bubble will be attached to.
 * @param {string} arrowPos Arrow position of bubble.
 * @param {object} onBlur OnBlur function.
 */
function addActiveBubble(type, element, arrowPos, onBlur) {
	if (typeof onBlur === "undefined") {
		onBlur = hideBubbles;
	}

	var oBubble = new activeBubble(type, element, arrowPos, onBlur);

	if (oBubble)
		g_oaActiveBubbles.push(oBubble);
}

/**
 * Calculates the position the bubble should be rendered based on the element it's attached to.
 * @param {string} type Bubble type.
 * @param {string} element HTML id of the element that the bubble is attached to.
 * @param {string} arrowPos Arrow position of bubble.
 */
function calculateBubblePosition(type, element, arrowPos) {
	var oPos = {};
	var iTop = 0;

	if ($("#" + element).exists()) {
		oPos = $("#" + element).offset();
		// Calculate the top position.
		var szElementHeight = $("#" + element).css("height");
		var iHdiff = (parseInt(szElementHeight.substring(0, szElementHeight.indexOf("px")), 10)) + (type == "CustomActionMenuContainer" ? 0 : 15);
		iTop = oPos.top + iHdiff;
	}
	else {
		oPos.top = getScrollAmountY();
		iTop = getScrollAmountY() + 15;
		oPos.right = getClientWidth();
		oPos.left = oPos.right - 50;
	}

	// Calculate the left position.
	var iLeft = 0;
	if (arrowPos == "right") {
		var szWidth = $("#divSpeech" + type).css("width");
		var iWidth = parseInt(szWidth.substring(0, szWidth.indexOf("px")), 10);
		// Width of bubble - (pixel indentation of arrow (85%)) + (half the pixel width of icon).
		var iWdiff = iWidth - (iWidth * .15) + (24 / 2);
		iLeft = oPos.left - iWdiff;
	} else {
		var szWidth = $("#divSpeech" + type).css("width");
		var iWidth = parseInt(szWidth.substring(0, szWidth.indexOf("px")), 10);
		// Width of bubble - (pixel indentation of arrow (85%)) + (half the pixel width of icon).
		var iWdiff = iWidth - (iWidth * .85) - (24 / 2);
		iLeft = oPos.left - iWdiff;
	}

	if (type == "CustomActionMenuContainer") {
		var szWidth = $("#divSpeech" + type).css("width");
		var iWidth = parseInt(szWidth.substring(0, szWidth.indexOf("px")), 10);
		// Width of bubble - (pixel indentation of arrow (45%)) + (half the pixel width of icon).
		var iWdiff = iWidth - (iWidth * .57) - (24 / 2);
		iLeft = oPos.left - iWdiff;
	}

	var iRight = (iLeft + $("#divSpeech" + type).width());
	if (iRight > $(window).width()) // if the bubble would show outside of the available window space
		iLeft -= iRight - $(window).width() + 10; // move the bubble back into the window space.

	if (type === "ContactDetails") {
		iTop = oPos.top;
		iLeft = oPos.left + 20;
	}

	// Set the position
	$("#divSpeech" + type).css("top", iTop);
	$("#divSpeech" + type).css("left", iLeft);
	$("#divSpeech" + type).css("z-index", 1000 + (10 * g_iCurrLockingLevel) + 1);
}

/**
 * Displays a Success Bubble
 * @param {string} element HTML id of the element that the bubble is attached to.
 * @param {string} content Contents of bubble.
 * @param {boolean} addDetails True if extra details need to be added  to the bubble like errors.
 * @param {number} width Width of bubble.
 * @param {string} arrowPos Arrow position of bubble.
 * @param {string=} fixAtElementPos Position to fix bubble at.
 * @param {number=} hideMilliseconds Optional milliseconds to hide the bubble after, otherwise a click is required to hide it.
 */
function displaySuccessBubble(element, content, addDetails, width, arrowPos, fixAtElementPos, hideMilliseconds) {
	displayBubble("Success", element, content, addDetails, width, arrowPos, "", fixAtElementPos, hideMilliseconds);
}

/**
 * Displays a Failure Bubble
 * @param {string} element HTML id of the element that the bubble is attached to.
 * @param {string} content Contents of bubble.
 * @param {bool} addDetails True if extra details need to be added  to the bubble like errors.
 * @param {int} width Width of bubble.
 * @param {string} arrowPos Arrow position of bubble.
 * @param {string=} fixAtElementPos Position to fix bubble at.
 */
function displayFailureBubble(element, content, addDetails, width, arrowPos, fixAtElementPos) {
	displayBubble("Fail", element, content, addDetails, width, arrowPos, "", fixAtElementPos);
}

/**
 * Displays a Warning Bubble
 * @param {string} element HTML id of the element that the bubble is attached to.
 * @param {string} content Contents of bubble.
 * @param {bool} addDetails True if extra details need to be added  to the bubble like errors.
 * @param {int} width Width of bubble.
 * @param {string} arrowPos Arrow position of bubble.
 * @param {string=} fixAtElementPos Position to fix bubble at.
 */
function displayWarningBubble(element, content, addDetails, width, arrowPos, fixAtElementPos) {
	displayBubble("Warning", element, content, addDetails, width, arrowPos, "", fixAtElementPos);
}

/**
 * Displays a Info Bubble
 * @param {string} element HTML id of the element that the bubble is attached to.
 * @param {string} content Contents of bubble.
 * @param {bool} addDetails True if extra details need to be added  to the bubble like errors.
 * @param {int} width Width of bubble.
 * @param {string} arrowPos Arrow position of bubble.
 * @param {string=} fixAtElementPos Position to fix bubble at.
 */
function displayInfoBubble(element, content, addDetails, width, arrowPos, fixAtElementPos) {
	displayBubble("Info", element, content, addDetails, width, arrowPos, "", fixAtElementPos);
}

/**
 * Displays the custom action menu container.
 * @param {string} element HTML id of the element that the bubble is attached to.
 * @param {string} content Contents of bubble.
 * @param {bool} addDetails True if extra details need to be added  to the bubble like errors.
 * @param {int} width Width of bubble.
 * @param {string} arrowPos Arrow position of bubble.
 * @param {string} fixAtElementPos Position to fix bubble at.
 */
function displayCustomActionMenuContainer(element, content, addDetails, width, arrowPos, fixAtElementPos) {
	displayBubble("CustomActionMenuContainer", element, content, addDetails, width, arrowPos, "", fixAtElementPos);
}

/**
 * Displays a confirm bubble.
 * @param {string} element HTML id of the element that the bubble is attached to.
 * @param {string} content Contents of bubble.
 * @param {string} confirmAction Code to be executed when the user uses the confirm button.
 * @param {string} cancelAction Code to be executed when the user uses  the cancel button.
 * @param {number} width Width of bubble.
 * @param {string} arrowPos Arrow position of bubble.
 * @param {object} onBlur OnBlur function.
 * @param {string=} fixAtElementPos Position to fix bubble at.
 */
function displayConfirmBubble(element, content, confirmAction, cancelAction, width, arrowPos, onBlur, fixAtElementPos) {
	// Unbind all previous events.
	$("#lnkSpeechConfirm_Confirm").unbind("click");
	$("#lnkSpeechConfirm_Cancel").unbind("click");
	// Add these events.
	$("#lnkSpeechConfirm_Confirm").click(function (event) {
		if (event.handled != true) {
			hideBubble('Confirm');
			if (typeof confirmAction === "function") confirmAction();
			else eval(confirmAction);
			event = null;
		}
	});
	$("#lnkSpeechConfirm_Cancel").click(function (event) {
		if (event.handled != true) {
			hideBubble('Confirm');
			if (typeof cancelAction === "function") cancelAction();
			else eval(cancelAction);
			event = null;
		}
	});
	displayBubble("Confirm", element, content, "", width, arrowPos, onBlur, fixAtElementPos);
}

/**
 * Displays a confirm bubble, with function callbacks.
 * @param {string} element HTML id of the element that the bubble is attached to.
 * @param {string} content Contents of bubble.
 * @param {function} confirmAction Function to be executed when the user clicks the confirm button.
 * @param {function} cancelAction Function to be executed when the user clicks the cancel button.
 * @param {number} width Width of bubble.
 * @param {string} arrowPos Arrow position of bubble.
 * @param {object} onBlur OnBlur function.
 * @param {string} fixAtElementPos Position to fix bubble at.
 */
function displayConfirmBubbleFunc(element, content, confirmAction, cancelAction, width, arrowPos, onBlur, fixAtElementPos) {
	// Unbind all previous events.
	$("#lnkSpeechConfirm_Confirm").unbind("click");
	$("#lnkSpeechConfirm_Cancel").unbind("click");
	// Add these events.
	$("#lnkSpeechConfirm_Confirm").click(function (event) {
		if (event.handled != true) {
			hideBubble('Confirm');
			if (confirmAction) {
				confirmAction();
			}
			event = null;
		}
	});
	$("#lnkSpeechConfirm_Cancel").click(function (event) {
		if (event.handled != true) {
			hideBubble('Confirm');
			if (cancelAction) {
				cancelAction();
			}
			event = null;
		}
	});
	displayBubble("Confirm", element, content, "", width, arrowPos, onBlur, fixAtElementPos);
}

/**
 * Displays a choices bubble.
 * @param {string} header Header to display at the top of the bubble.
 * @param {array} choiceObjects Objects which hold the message + function for the choice.
 * @param {Object} cancelFunction Code to be executed when the user uses the cancel button.
 * @param {number} width Width of bubble.
 * @param {string=} optionalMessage An optional message to be displayed underneath the bubble.
 */
function displayChoiceBubble(header, choiceObjects, cancelFunction, width, optionalMessage) {
	// lock the screen.
	lockWindow();
	var bPopupOpen = $("#divSpeechChoice").is(':visible');

	// Unbind previous close events.
	$("#lnkSpeechChoice_Cancel").unbind("click");

	// Clear the optional message
	$("#spnSpeechChoice_OptionalMessage").empty();

	// Add the close event.
	$("#lnkSpeechChoice_Cancel").click(function (event) {
		if (event.handled !== true) {
			$("#divSpeechChoice").fadeOut();
			if (typeof cancelFunction === "function") {
				cancelFunction();
			}
			g_iCurrLockingLevel--;
			unlockWindow();
			event = null;
		}
	});

	// Add the header.
	$("#spnSpeechChoice_Header").html(header);
	// Clear previous choices.
	var oChoices = $("#tbodySpeechChoice_Choices");
	oChoices.empty();

	// Render each of the choices.
	for (var i = 0; i < choiceObjects.length; i++) {
		var oChoice = choiceObjects[i];
		var oRow = $('<tr/>'); // create new row.
		oRow.append($('<td/>', { width: '10%' })); // add an empty column.

		// create text column.
		var oTextColumn = $('<td/>', { width: '75%', align: 'left' });
		var oChoiceText = $('<li/>').append(oChoice.message);
		var oLineBreak = $('</br>');
		oTextColumn.append(oChoiceText);
		oTextColumn.append(oLineBreak);
		oRow.append(oTextColumn);

		// create button column.
		var oButtonColumn = $('<td/>', { align: 'right', valign: 'top', width: '10%' });
		var oImg = $('<img/>', { src: 'img/icon/mod/approve24.svg', align: 'absmiddle' });
		oImg.attr("draggable", "false");
		var oAnchor = $('<a/>')
			// create anchor & throw it related on-clicks.
			.click(oChoice.action)
			.click(function () {
				$("#divSpeechChoice").fadeOut();
				g_iCurrLockingLevel--;
				unlockWindow();
			});
		//.click(unlockWindow);
		oAnchor.append(oImg);
		oButtonColumn.append(oAnchor);
		oRow.append(oButtonColumn);
		oRow.append($('<td/>', { width: '5%' })); // add an empty column.
		// Add the choice.
		oChoices.append(oRow);
	}

	if (typeof optionalMessage !== 'undefined' && optionalMessage.length > 0) {
		$("#spnSpeechChoice_OptionalMessage").html(optionalMessage);
	}

	if (!bPopupOpen) {
		g_iCurrLockingLevel++;
	}
	// increment the zIndex to go above the lock.
	$("#divSpeechChoice").css("z-index", 1000 + (10 * g_iCurrLockingLevel) + 2);
	$("#divSpeechChoice").css("width", width);

	centerDisplayDiv('divSpeechChoice');

	$("#divSpeechChoice").fadeIn();
}

/**
 * Shows the speech bubble in the required location.
 * @param {string} type Bubble type.
 * @param {string} element HTML id of the element that the bubble is attached to.
 * @param {string} content Contents of bubble.
 * @param {bool} addDetails True if extra details need to be added  to the bubble like errors.
 * @param {int} width Width of bubble.
 * @param {string} arrowPos Arrow position of bubble.
 * @param {object} onBlur OnBlur function.
 * @param {string} fixAtElementPos Position to fix bubble at.
 * @param {number=} hideMilliseconds Optional milliseconds to hide the bubble after, otherwise a click is required to hide it.
 */
function displayBubble(type, element, content, addDetails, width, arrowPos, onBlur, fixAtElementPos, hideMilliseconds) {
	if ($("#divSpeech" + type).exists() && $("#" + element).exists()) {
		if (isNumeric(width) && width > 200)
			$("#divSpeech" + type).css("width", width);

		// Set the content.
		if (content.length > 0) {
			var szContentHTML = "<span>" + content + "</span>";

			$("#tdSpeech" + type + "_Content").html(szContentHTML);
		}

		// Reset the bubble to basic mode.
		if (addDetails && $("#trSpeech" + type + "_AddContent").exists())
			$("#trSpeech" + type + "_AddContent").toggle(true);				// Show link to show details.

		if ($("#tdSpeech" + type + "_EmailErr").exists())
			$("#tdSpeech" + type + "_EmailErr").toggle(false);				// Hide Email Icon.

		if ($("#trSpeech" + type + "_ErrorDetails").exists())
			$("#trSpeech" + type + "_ErrorDetails").toggle(false);			// Hide Error Details.

		// Display the div.
		// Queue this in case we're still in the process of hiding the bubble.
		$("#divSpeech" + type).queue(function () {
			if (!isNothing(fixAtElementPos) && fixAtElementPos) {
				// Set the position to that of the element we have passed in.
				$("#divSpeech" + type).css("top", $("#" + element).offset().top);
				$("#divSpeech" + type).css("left", $("#" + element).offset().left);
				$("#divSpeech" + type).css("z-index", 1000 + (10 * g_iCurrLockingLevel) + 1);
			}
			else
				calculateBubblePosition(type, element, arrowPos);

			if (type != "CustomActionMenuContainer") {
				$("#divSpeech" + type).fadeIn();
				$("#divSpeech" + type).dequeue();
			}
			else {
				var iNewHeight = $("#divSpeechCustomActionMenu").height() + 75;

				if (g_oUserProfile.instanceSkinType == "0") {
					$("#divSpeechCustomActionMenuContainer").css("display", "block");
					$("#divSpeechCustomActionMenuContainer").css("height", iNewHeight);
				}
				else {
					if ($("#divSpeechCustomActionMenuContainer").height() > 0) {
						$("#divSpeechCustomActionMenuContainer").animate({ height: "0px" }, 300);
					}
					else {
						$("#divSpeechCustomActionMenuContainer").animate({ height: iNewHeight.toString() + "px" }, 300);
					}
				}

				$("#divSpeech" + type).dequeue();
			}

			if (hideMilliseconds && szContentHTML) {
				setTimeout(function () {
					if ($("#tdSpeech" + type + "_Content").html() === szContentHTML) {
						$("#divSpeech" + type).fadeOut();
					}
				}, hideMilliseconds);
			}
		});

		// Add the bubble to the active bubbles object.
		addActiveBubble(type, element, arrowPos, onBlur);
	}
}

/**
 * Add drag and drop events to a given element.
 * @param {any} element - element
 * @param {any} namespace - namespace for droppedFile function
 */
function addDragDropAssetEvents(element, namespace) {
	$("#" + element).attr("ondragover", "dragOverFile(event);");
	$("#" + element).attr("ondragleave", "dragLeaveFile(event);");
	$("#" + element).attr("ondrop", "droppedFile(event, " + namespace + ");");
}

/**
 * Remove drag and drop events from a given element.
 * @param {any} element - element
 */
function removeDragDropAssetEvents(element) {
	$("#" + element).attr("ondragover", "");
	$("#" + element).attr("ondragleave", "");
	$("#" + element).attr("ondrop", "");
}

/**
 * Fades out the speech bubble(s) - unknown.
 */
function hideBubbles() {
	$("#divSpeechSuccess").fadeOut();
	$("#divSpeechFail").fadeOut();
	$("#divSpeechWarning").fadeOut();
	$("#divSpeechConfirm").fadeOut();
	$("#divSpeechInfo").fadeOut();
	$("#divSpeechContactDetails").fadeOut();

	// If the pop-up exists, then for the classical UI we want to toggle it of, but for modern we want to animate it.
	if ($("#divSpeechCustomActionMenuContainer").exists()) {
		if (g_oUserProfile.instanceSkinType == "0") {
			$("#divSpeechCustomActionMenuContainer").css("display", "none");
			$("#divSpeechCustomActionMenuContainer").css("height", 0);
		}
		else {
			$("#divSpeechCustomActionMenuContainer").animate({ height: "0px" }, 300);
		}
	}

	g_oaActiveBubbles.length = 0;
}

/**
 * Fades out the speech bubble (specific).
 * @param {string} type Bubble type.
 */
function hideBubble(type) {
	$("#divSpeech" + type).fadeOut();

	for (var i = 0; i < g_oaActiveBubbles.length; i++) {
		if (g_oaActiveBubbles[i].type === type)
			g_oaActiveBubbles.slice(i, 1);
	}
}

/*
 * Display ToolTip.
 */

/**
 * Displays the tooltip pop-up.
 * @param {string} content Content of the tooltip.
 * @param {object} e JQuery even object.
 */
function displayToolTip(content, e) {
	var oGUI = $("#divToolTip");
	if (oGUI) {
		var iTop = 0;
		var iLeft = 0;
		if (e) {
			if (e.pageX || e.pageY) {
				iTop = e.pageY;
				iLeft = e.pageX;
			} else {
				iTop = e.clientY + getScrollAmountY();
				iLeft = e.clientX + getScrollAmountX();
			}
		}

		if (content != null && content.length > 0)
			$("#divToolTip_Content").html(content);

		oGUI.css("top", iTop + 10);
		oGUI.css("left", iLeft + 10);
		oGUI.css("z-index", 1000 + (10 * g_iCurrLockingLevel) + 1);
		oGUI.css("display", "");
	}
}

/**
 * Hides the tooltip pop-up.
 */
function hideToolTip() {
	if ($("#divToolTip").exists()) {
		$("#divToolTip").fadeOut();
	}
}

/*
 *		- - - G U I   M E T H O D S - - -
 */

/**
 * Returns the correct height of the browser window.
 * @returns {int} Correct height of browser window.
 */
function getClientHeight() {
	var iClientHeight = $(window).height();
	return iClientHeight;
}

/**
 * Returns the correct width of the browser window.
 * @returns {int} Correct width of the browser window.
 */
function getClientWidth() {
	var iClientWidth = $(window).width();
	return iClientWidth;
}

/**
 * Calculates the correct X position to place an object in the centre of the window.
 * @param {int} objectWidth Width of object to center.
 * @returns {int} X position.
 */
function calculateCentralXCoordinate(objectWidth) {
	var iWidth = getClientWidth();
	var iLeft = getScrollAmountX() + (iWidth - objectWidth) / 2;
	return iLeft;
}

/**
 * Calculates the correct Y position to place an object in the centre of the window.
 * @param {int} objectHeight Height of the object to center.
 * @returns {int} Y position.
 */
function calculateCentralYCoordinate(objectHeight) {
	var iHeight = getClientHeight();
	var iTop = getScrollAmountY() + (iHeight - objectHeight) / 2;
	return iTop
}

/**
 * Returns the correct horizontal scrolling amount of the browser window.
 * @returns {int} Correct horizontal scrolling amount.
 */
function getScrollAmountX() {
	var iScrollAmountX = $(window).scrollLeft()
	return iScrollAmountX;
}

/**
 * Returns the correct vertical scrolling amount of the browser window.
 * @returns {int} Correct vertical scrolling amount.
 */
function getScrollAmountY() {
	var iScrollAmountY = $(window).scrollTop();
	return iScrollAmountY;
}

/**
 * Returns the correct scrolling height of the HTML Page / Document.
 * @returns {int} Correct scrolling height of the HTML Page / Document.
 */
function getScrollHeight() {
	var iScrollHeight = $(document).height();
	return iScrollHeight;
}

/**
 * Returns the correct scrolling width of the HTML Page / Document.
 * @returns {int} Correct scrolling width of the HTML Page / Document.
 */
function getScrollWidth() {
	var iScrollWidth = $(document).width();
	return iScrollWidth;
}

/**
 * Scroll element into view if not on the screen.
 * @param {element} target target element, usually the row you want to scroll into view.
 */
function scrollIntoViewIfNeeded(target) {
	var rect = target.getBoundingClientRect();
	if (rect.bottom > window.innerHeight) {
		target.scrollIntoView(false);
	}
	if (rect.top < 0) {
		target.scrollIntoView();
	}
}

/**
 * Hides the selected element(s) from the page (prevents unwanted LAYER interference).
 * @param {string} tagName Name of tag to hide.
 */
function hideElement(tagName) {
	// IE and compatibles only.
	if (navigator.appName.indexOf("Microsoft") >= 0 && parseFloat(navigator.appVersion.split("MSIE")[1]) < 7) {
		var iLen = document.all.tags(tagName).length;
		for (i = 0; i < iLen; i++) {
			o = document.all.tags(tagName)[i];
			if (o)
				o.style.visibility = "hidden";
		}
	}
	return
}

/**
 * Update element height to fill the remaining pop-up space.
 * @param {string} elementId HTML Id of the element to resize.
 * @param {string} parentId HTML Id of the elements parent (pop-up).
 * @param {int} elementOffset Any offset which should be taken into account when resizing.
 * @returns {int} New Height.
 */
function resizeHeightToFillSpace(elementId, parentId, elementOffset) {
	// If no parentId has been passed, assume divPopUpContent_Content.
	if (!parentId) {
		parentId = "divPopUpContent_Content";
	}

	// If no offset has been passed in set it to 0.
	if (!elementOffset) {
		elementOffset = 0;
	}

	var oParentElement = $("#" + getContentPopup(true) + " #" + parentId);

	// Get a reference to the target element.
	var oElement = $("#" + elementId);

	if (!oElement.position) {
		console.log("Failed to return element: " + elementId);
		return;
	}

	// Get the required dimensions.
	var dPopUpContentHeight = oParentElement.height();
	var dAreaOffsetTop = oElement.position().top;

	var iPadding = 0;
	oParentElement.find("table:not(#" + elementId + ", #" + elementId + " *)").each(function () {
		if ($(this).is(":visible") && this.cellPadding.length > 0 && $.contains(this, elementId)) {
			iPadding += parseInt(this.cellPadding, 10);
		}
	});

	// Calculate the new height of the target element, taking into account the padding (min 5), margin, and border on the target element.
	var iHeight = (dPopUpContentHeight - dAreaOffsetTop) - (oElement.outerHeight() - oElement.height()) - (iPadding > 5 ? iPadding : 5) - elementOffset;

	if (iHeight > 0) {
		oElement.css("height", iHeight);
	}

	return iHeight;
}

/**
 * Renders content based on the current browser.
 * @param {string} elementID HTML id of the element.
 * @param {string} content Content to render.
 */
function renderContent(elementID, content) {
	// If Internet Explorer browser.
	if (g_szBrowserName === "IE") {
		document.getElementById(elementID).innerHTML = content;
	}
	else {
		$("#" + elementID).html(content);
	}
}

/**
 * Re-displays the previously hidden element (see function "hideElement").
 * @param {string} elementID HTML Id of the element to show.
 */
function showElement(elementID) {
	// IE and compatibles only.
	if (navigator.appName.indexOf("Microsoft") >= 0 && parseFloat(navigator.appVersion.split("MSIE")[1]) < 7) {
		var iLen = document.all.tags(elementID).length;
		for (i = 0; i < iLen; i++) {
			o = document.all.tags(elementID)[i];
			if (o)
				o.style.visibility = "visible";
		}
	}
	return;
}

/**
 * Closes the progress bar.
 * @param {boolean} completeCallback - Indicate if the callback should be completed if defined.
 */
function closeProgressBar(completeCallback) {
	if (!isDefined(completeCallback)) {
		completeCallback = true;
	}

	persistentUnlockWindow();
	$("#divProjectProgress").hide();
	$("#divPersistentLock").hide();
	if (completeCallback && typeof (g_oProgressBarSF) != "undefined" && g_oProgressBarSF != "") {
		g_oProgressBarSF.processMeEx("CLOSEPOPUP");
	}

	$("#prgMessage").text("");

	g_oSFBatchEdit.g_bCompleteAll = false;
}

/**
* Opens the progress bar at the correct location on the screen.
*/
function showProgressBar(oSF) {
	persistentLockWindow();

	g_oProgressBarSF = oSF;
	$("#prgCloseIcon").hide();
	$("#prgProjects").val(0);
	$("#divProjectProgress").css("z-index", 10000001);

	// Calculate the Pop-up position and content sizes.
	var idivHeight = (20 * getClientHeight()) / 100;
	var idivWidth = (50 * getClientWidth()) / 100;
	$("#divProjectProgress").css("height", idivHeight);
	$("#divProjectProgress").css("width", idivWidth);

	// Calculate the central position.
	var iTop = calculateCentralYCoordinate(parseInt(idivHeight, 10));
	var iLeft = calculateCentralXCoordinate(parseInt(idivWidth, 10));

	// Apply the CSS.
	$("#divProjectProgress").css("top", iTop);
	$("#divProjectProgress").css("left", iLeft);

	// Reset progress bar percentage.
	$("#prgPercentage").text("0%");

	// Show the window.
	$("#divProjectProgress").show();
}

/**
* Updates the progress bar percentage with the passed value.
*/
function updateProgressBarPercentage(Percentage, DisplayPercentage, Message, RemainingTime) {
	$("#prgProjects").val(Percentage);
	$("#prgPercentage").text(DisplayPercentage + "%");
	$("#prgMessage").text(Message);
	$("#prgRaimainingTime").text(RemainingTime);
}

/*
 *  - - - C O O K I E   M E T H O D S - - -
 */

/**
 * Function to retrieve a client-side cookie.
 * (Plug-in Required for JQuery).
 * @param {string} szName Name of cookie to get.
 * @returns {string} Cookie.
 */
function getCookie(szName) {
	var szResult = null;
	var szCookies = " " + document.cookie + ";";
	var szSearchName = " " + szName + "=";
	var iStart = szCookies.indexOf(szSearchName);
	if (iStart != -1) {
		iStart += szSearchName.length;
		var iEnd = szCookies.indexOf(";", iStart);
		szResult = unescape(szCookies.substring(iStart, iEnd));
	}
	return szResult;
}

/**
 * Function to set a client-side cookie that persists only
 * until the user closes the browser.
 * (Plug-in Required for JQuery).
 * @param {string} szName Name of cookie.
 * @param {type} szValue Value of cookie.
 */
function setCookie(szName, szValue) {
	document.cookie = szName + "=" + escape(szValue) + "; path=/";
}

/**
 * Function to set a client-side cookie that persists
 * until the date specified.
 * (Plug-in Required for JQuery).
 * @param {string} szName Name of cookie.
 * @param {string} szValue Value of the cookie.
 * @param {string} szDate Date in string form the cookie expires.
 */
function setCookieEx(szName, szValue, szDate) {
	document.cookie = szName + "=" + escape(szValue) + "; expires=" + szDate + "; path=/";
}

/*
 *		- - - V A L I D A T I O N   M E T H O D S - - -
 */

/**
 * Checks the passed parameter contains alphabetic characters only.
 * @param {string} text Text to validate.
 * @returns {bool} Is the text valid.
 */
function isAlpha(text) {
	var szTxt = text;
	var iLen = szTxt.length;
	for (var i = 0; i != iLen; i++) {
		var aChar = szTxt.substring(i, i + 1);
		aChar = aChar.toUpperCase();
		if (aChar < "A" || aChar > "Z") {
			return false;
		}
	}
	return true;
}

/**
 * Function to determine if a variable is defined or not.
 * @param {object} o Object to check is defined.
 * @returns {bool} True if the object is defined else false.
 */
function isDefined(o) {
	return (typeof o !== "undefined");
}

/**
 * Function to determine if a string is nothing or not.
 * @param {string} string String to check.
 * @returns {bool} True if the string is not nothing else false.
 */
function isNothing(string) {
	if (string != null && (string + "") != "") { return false; }
	else { return true; }
}

/**
 * Function to check that a string contains only numeric characters.
 * @param {string} value String to validate.
 * @param {bool} required Is the validation required.
 * @returns {bool} True if the string only contains numeric characters.
 */
function isNumeric(value, required) {
	var szType = typeof value;

	if (szType === "number") { return true; }
	else if (isNothing(value) && required) { return false; }
	else if (isNothing(value)) { return true; }
	else if (szType === "string") {
		var szTxt = value;
		var iLen = szTxt.length;
		for (var i = 0; i != iLen; i++) {
			var aChar = szTxt.substring(i, i + 1);
			if (aChar < "0" || aChar > "9") { return false; }
		}
		return true;
	}
	else {
		return false;
	}
}

/**
 * Function to trim blank spaces from a string.
 * @param {string} val String to trim blank spaces from
 * @returns {string} String with blank spaces trimmed.
 */
function trim(val) {
	if (typeof (val) != "undefined") {
		return val.replace(/^\s+|\s+$/g, "");
	}
	else {
		return "";
	}
}

/*
 *		- - - M I S C - - -
 */

/**
 * Prints a console error in an object format, useful for flagging
 * up if we have defensive code to check against corrupt objects
 * so we can work around them - but still make support aware something
 * is wrong.
 * @param {any} message info about what the error is, i.e. 'parent task is missing'.
 * @param {any} value the data relating to the error, i.e. the original task that caused the error.
 */
function reportDevError(message, value) {
	// Report the normal error as normal if we can,
	// if it's an error object we want browsers like chrome
	// to allow for it to be clickable.
	if (value && typeof value === 'object')
		console.error(value);

	var json = { message: message, value: value, source: new Error().stack };

	console.error(json);

	// add to application insights if available
	if (typeof appInsights !== "undefined") {
		appInsights.trackEvent({
			name: "A developer error has occurred.",
			properties: json
		});
	}
}

/**
 * Function to add a highlight to an element.
 * @param {object} element HTML Element to change.
 * @param {boolean|undefined} bAddTextBox Whether to re-add insightTextBoxClass
 * @param {number} iHighlightLength Length of time the element should be highlighted for (in milliseconds).
 */
function addInfoHighlight(element, bAddTextBox, iHighlightLength) {
	addHighlight(element, 'insightTextBoxInfo', bAddTextBox, iHighlightLength);
}

/**
 * Function to add a highlight to an element.
 * @param {object} element HTML Element to change.
 * @param {boolean|undefined=} bAddTextBox Whether to re-add insightTextBoxClass
 * @param {number=} iHighlightLength Length of time the element should be highlighted for (in milliseconds).
 */
function addErrorHighlight(element, bAddTextBox, iHighlightLength) {
	addHighlight(element, 'insightTextBoxError', bAddTextBox, iHighlightLength);
}

/**
 * Function to add a highlight to an element.
 * @param {object} element HTML Element to change.
 * @param {boolean|undefined=} bAddTextBox Whether to re-add insightTextBoxClass
 * @param {number=} iHighlightLength Length of time the element should be highlighted for (in milliseconds).
 */
function addSelectListErrorHighlight(element, bAddTextBox, iHighlightLength) {
	addHighlight(element, 'insightSelectListError', bAddTextBox, iHighlightLength);
}

/**
 * Function to add a highlight to an element.
 * @param {object} element HTML Element to change.
 * @param {boolean|undefined=} bAddTextBox Whether to re-add insightTextBoxClass
 * @param {number=} iHighlightLength Length of time the element should be highlighted for (in milliseconds).
 */
function addMultiSelectListErrorHighlight(element, bAddTextBox, iHighlightLength) {
	addHighlight(element, 'insightMultiSelectListError', bAddTextBox, iHighlightLength);
}

/**
 * Function to add a highlight to a text box element.
 * @param {object} element HTML Element to change.
 * @param {string} highlightClass Class to add.
 * @param {boolean|undefined} bAddTextBox Whether to re-add insightTextBoxClass
 * @param {number} iHighlightLength Length of time the element should be highlighted for (in milliseconds).
 */
function addHighlight(element, highlightClass, bAddTextBox, iHighlightLength) {
	// add highlight
	$(element).addClass(highlightClass);

	if (iHighlightLength > 0) {
		window.setTimeout(function () {
			if (bAddTextBox) {
				$(element).addClass('insightTextBox');
			}
			$(element).removeClass(highlightClass);
		}, iHighlightLength);
	}
}

/**
 * Function to add a highlight to a select list element.
 * @param {object} element HTML Element to change.
 * @param {string} highlightClass Class to add.
 * @param {boolean|undefined} bAddTextBox Whether to re-add insightTextBoxClass
 * @param {number} iHighlightLength Length of time the element should be highlighted for (in milliseconds).
 */
function addSelectListHighlight(element, highlightClass, bAddTextBox, iHighlightLength) {
	// add highlight
	$(element).addClass(highlightClass);

	if (iHighlightLength > 0) {
		window.setTimeout(function () {
			if (bAddTextBox) {
				$(element).addClass('insightSelectList');
			}
			$(element).removeClass(highlightClass);
		}, iHighlightLength);
	}
}

/**
 * Removes all error highlights.
 */
function removeErrorHighlights() {
	// Remove existing error highlights.
	$(".insightTextBoxError").addClass("insightTextBox")
		.removeClass("insightTextBoxError");
	// Remove existing error highlights.
	$(".insightSelectListError").addClass("insightSelectList")
		.removeClass("insightSelectListError");
	$(".insightMultiSelectListError")
		.removeClass("insightMultiSelectListError");
}

/**
 * Function to get a current date time string from the server.
 * @returns {Object} Current date time of the server.
 */
function getCurrentDateTime() {
	var oDate = g_dtRequestServerTime; // Default to the initial call.

	// If we've not been called already:
	if (!g_dtRequestServerTime) {
		// Go to the server & get our initial request time.
		var szDate = $.ajax({
			type: "GET",
			url: "apps/portal/svr/Default.aspx"
				+ "?Action=GETCURRENTDATETIME"
				+ "&LoginId=" + g_oUserProfile.loginId,
			async: false
		}).responseText;

		oDate = new Date(szDate.replace(/\r\n/g, ""));
		g_dtRequestServerTime = new Date(oDate.getTime()); // Servers time.
		g_dtRequestLocalTime = new Date(); // Users local time.
	}
	// We've already been there once.. lets calculate the difference
	// in time since our last request.
	else {
		// Get the offset from now & the initial request time.
		var iTimeOffset = new Date().getTime() - g_dtRequestLocalTime.getTime();
		oDate = new Date(g_dtRequestServerTime.getTime() + iTimeOffset);
	}

	oDate.setUTCMilliseconds(0);

	return oDate;
}

/**
 * Escapes problematic characters in attributes.
 * @param {str} - String to be escaped.
 * @returns {string} - The escaped string
 */
function htmlEscape(str) {
	return str
		.replace(/&/g, '&amp;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;');
}

/**
 * Un-escapes HTML entities when rendering
 * @param {str} - String to be un-escaped.
 * @returns {string} - The un-escaped string.
 */
function htmlUnescape(str) {
	return str
		.replace(/&quot;/g, '"')
		.replace(/&#39;/g, "'")
		.replace(/&lt;/g, '<')
		.replace(/&gt;/g, '>')
		.replace(/&nbsp;/g, '\u00A0')
		.replace(/&amp;/g, '&');
}

/**
 * Decodes HTML encoded strings
 * @param {str} - String to be decoded.
 * @returns {string} - The decoded string.
 */
function htmlDecode(str) {
	return $("<div/>").html(str).text();
}

/**
 * Encodes HTML encoded strings
 * @param {str} - String to be encoded.
 * @returns {string} - The encoded string.
 */
function htmlEncode(str) {
	return $("<div/>").html(str).html();
}

/**
 * Removes a value from a passed in string list.
 * @param {string} list - The string list.
 * @param {string} value - The value to be removed
 * @param {string} separator - Optional separator character. Defaults to a comma if not passed in.
 * @returns {string} - The new list with the values removed.
 */
function removeValue(list, value, separator) {
	// Set the default separator.
	separator = separator || ",";
	// Split the list into an array.
	var oValueArray = list.split(separator);

	// Loop through and removed the value.
	for (var i = 0; i < oValueArray.length; i++) {
		if (oValueArray[i].trim() == value.trim()) {
			oValueArray.splice(i, 1);
			return oValueArray.join(separator);
		}
	}
	return list;
}

/**
 * Swaps an image objects source.
 * @param {string} imgElement HTML id of the img element to change the src of.
 * @param {string} newImageSrc The source of the image to swap to.
 */
function swapImage(imgElement, newImageSrc) {
	if ($("#" + imgElement).exists())
		$("#" + imgElement).attr("src", newImageSrc);
}

/**
 * Function to set the client platform.
 * @param {int} platformId Id of the platform.
 * @param {string} platformName Name of the platform.
 */
function setPlatform(platformId, platformName) {
	g_szCurrentPlatformName = platformName;
	g_iCurrentPlatform = platformId;
}

/**
 * Function to set the client platform.
 * @param {string} name Name of the browser.
 * @param {string} ver The browser version.
 */
function setBrowser(name, ver) {
	g_szBrowserName = name;
	g_szBrowserVersion = ver;
}

/**
 * Returns the root path to the site.
 * @returns {string} Full path of the web site.
 */
function getRootWebSitePath() {
	var szLocation = document.location.toString();
	var szApplicationNameIndex = szLocation.indexOf('/', szLocation.indexOf('://') + 3);
	var szApplicationName = szLocation.substring(0, szApplicationNameIndex) + '/';
	var szWebFolderIndex = szLocation.indexOf('/', szLocation.indexOf(szApplicationName) + szApplicationName.length);
	var szWebFolderFullPath = szLocation.substring(0, szWebFolderIndex);

	return szWebFolderFullPath;
}

function getCurrentPopupDivId() {
	if (g_iCurrLockingLevel === 0) return '';
	else return g_iCurrLockingLevel === 1 ? "divPopUp" : "divPopUp" + g_iCurrLockingLevel;
}

/**
 * Returns the id of the current pop-ups close button.
 * */
function getCurrentPopupCloseId() {
	return g_iCurrLockingLevel === 1 ? "aPopup_Close" : "aPopup" + g_iCurrLockingLevel + "_Close";
}

/**
 * Returns the id of the current pop-ups title.
 * */
function getCurrentPopupTitleId() {
	return g_iCurrLockingLevel === 1 ? "tdPopupTitle" : "tdPopup" + g_iCurrLockingLevel + "Title";
}

/**
 * Scrolls the current pop-ups content div down to the target element assuming the div supports this
 * (must have a height set and be set to scrollable).
 * @param {string} targetElement HTML id of the element to scroll to.
 */
function scrollToElement(targetElement) {
	if (!isNothing(targetElement)) {
		// Use current locking level to determine if a pop-up is open.
		if (g_iCurrLockingLevel > 0) {
			// animate over 2 seconds.
			$("#" + getContentPopup(true)).find("#divPopUpContent_Content").animate({
				scrollTop: $("#" + targetElement).offset().top - $("#" + getContentPopup(true)).find("#divPopUpContent_Content").offset().top - 20
			}, 2000);
		}
		else {
			$("#divWrapper").find("#divPopUpContent_Content").animate({
				scrollTop: $("#" + targetElement).offset().top - $("#divWrapper").find("#divPopUpContent_Content").offset().top - 20
			}, 2000);
		}
	}
}

/**
 * Instantly scrolls the current pop-ups content div down to the target element assuming the div supports this.
 * (must have a height set and be set to scrollable).
 * @param {string} targetElement HTML id of the element to scroll to.
 */
function scrollToElementFast(targetElement) {
	if (!isNothing(targetElement)) {
		// Use current locking level to determine if a pop-up is open.
		if (g_iCurrLockingLevel > 0) {
			// animate over 2 seconds.
			$("#" + getContentPopup(true)).find("#divPopUpContent_Content").animate({
				scrollTop: $("#" + targetElement).offset().top - $("#" + getContentPopup(true)).find("#divPopUpContent_Content").offset().top - 20
			}, 0);
		}
		else {
			$("#divWrapper").find("#divPopUpContent_Content").animate({
				scrollTop: $("#" + targetElement).offset().top - $("#divWrapper").find("#divPopUpContent_Content").offset().top - 20
			}, 0);
		}
	}
}

/**
 * Performs a deep copy on an array.
 * @param {array} oldArray Array to deep copy.
 * @returns {array} The deep copy of the array.
 */
function deepCopyArray(oldArray) {
	return jQuery.extend(true, [], oldArray);
}

/**
 * Performs a deep copy on an object.
 * @param {object} oldObject Object to deep copy.
 * @returns {object} The deep copy of the object.
 */
function deepCopyObject(oldObject) {
	return jQuery.extend(true, {}, oldObject);
}

/**
 * Performs a deep copy on an array of objects.
 * @param {Object[]} oldArray Array of objects to deep copy.
 * @returns {Object[]} The deep copy of the array.
 */
function deepCopyObjectArray(oldArray) {
	return oldArray.map(deepCopyObject);
}

/**
 * Get project level prompt from number.
 * @param {number} projectLevelNumber - The Project level number.
 * @returns {string} The project level prompt.
 */
function getProjectLevelPromptFromNumber(projectLevelNumber) {
	switch (projectLevelNumber) {
		case 1:
			return c_szTerminology_Project;
		case 2:
			return c_szTerminology_SKU;
		case 3:
			return c_szTerminology_Component;
	}
}

/**
 * Replaces any escaped newlines within strings with HTML breaks.
 * @param {string} input String to perform replace on.
 * @returns {string} String with newlines replaced with HTML breaks.
 */
function formatStringForHTML(input) {
	var szOutput = "";
	if (input.length > 0) {
		// Convert new lines;
		szOutput = input.replace(/\r?\n/g, "<br/>");
	}
	return szOutput;
}

/**
 * Gets the class for colour coding the project / task specifically for text.
 * @param {number} onTimeStatus Id of the on time status.
 * @param {number} taskStatus ID of the task status.
 * @returns {string} Class to be used for the provided on time status.
 */
function getOnTimeStatusTextClass(onTimeStatus, taskStatus) {
	// Some classes have coloured backgrounds, so we switch them to the non-completed
	// version if so.
	var value = onTimeStatus;

	if (value === 5) {
		value = 1;
	}
	else if (value === 6) {
		value = 3;
	}

	return getOnTimeStatusClass(value, taskStatus);
}

/**
 * Gets the class for colour coding the project / task based on its on time status.
 * @param {number} onTimeStatus Id of the on time status.
 * @param {number} taskStatus ID of the task status.
 * @returns {string} Class to be used for the provided on time status.
 */
function getOnTimeStatusClass(onTimeStatus, taskStatus) {
	var szClass = "";
	switch (onTimeStatus) {
		case 0:
			szClass = "resultRow_Draft";
			break;
		case 1:
			szClass = "resultRow_OnTime";
			break;
		case 2:
			szClass = "resultRow_BehindSchedule";
			break;
		case 3:
			szClass = "resultRow_Late";
			break;
		case 4:
			szClass = "resultRow_Abandoned";
			break;
		case 5:
			szClass = "resultRow_Completed_OnTime";
			break;
		case 6:
			szClass = "resultRow_Completed_Late";
			break;
	}

	// If the task on time status is abandoned but our task is 'active',
	// this implies that the task is at sheriff monitoring. The 'taskStatus'
	// can be undefined to ensure that no adjustments are made.
	if (onTimeStatus === 4 &&
		(taskStatus === 0 ||	// Pending
			taskStatus === 1 ||		// In-Progress
			taskStatus === 3)) {	// On-Hold
		szClass = "resultRow_Draft";
	}

	return szClass;
}

/**
 * Helper function to filter out non-ASCII characters from a string.
 * This is used to sanitise file names and paths in Dragonfly.
 * @param {string} value - The string value to be filtered.
 * @param {string} replaceWith - The string that will be used to replace the filtered characters.
 * @returns {string} - Returns the filtered string.
 */
function replaceNonAsciiChars(value, replaceWith) {
	var szRemainingNonASCIICharacters = /[^\u0020-\u007E\u00C0-\u00F6\u00F8-\u00FF]/g;
	return value.replace(szRemainingNonASCIICharacters, replaceWith);
}

/**
 * Helper function to filter out characters that are illegal for Dragonfly URLs from a string.
 * This is used to sanitise file names and paths in Dragonfly.
 * @param {string} value - The string value to be filtered.
 * @param {string} replaceWith - The string that will be used to replace the filtered characters.
 * @returns {string} - Returns the filtered string.
 */
function replaceIllegalURLChars(value, replaceWith) {
	var szIllegalURLChars = /[\\#%$*+\/:<>?,';|\"]/g;
	return value.replace(szIllegalURLChars, replaceWith);
}

/*
 *		- - - S E L E C T   L I S T   R O U T I N E S - - -
 */

/**
 * Appends an item into a selection list.
 * @param {string} listName HTML id of the list.
 * @param {string} value Value of the option to append to the list.
 * @param {string} text text of the option to append to the list.
 * @param {string} parentDiv HTML id of the parent div.
 */
function addListItemOption(listName, value, text, parentDiv) {
	$((!isNothing(parentDiv) ? "#" + parentDiv + " " : "") + "#" + listName).append($('<option>', {
		value: value,
		text: text
	}));
}

/**
 * Clears all options from the list box.
 * @param {string} listName HTML id of the list.
 * @param {bool} addBlank True to add blank value to the list after its being cleared.
 * @param {string} parentDiv HTML id of the parent div.
 */
function clearListItem(listName, addBlank, parentDiv) {
	$((!isNothing(parentDiv) ? "#" + parentDiv + " " : "") + "#" + listName).find('option').remove().end();
	if (addBlank)
		addListItemOption(listName, 0, "");
}

/**
 * Gets the text for a specific list item value.
 * @param {string} listName HTML id of the list.
 * @param {string} value Value of the option to get the text for.
 * @param {string} parentDiv HTML id of the parent div.
 * @returns {string} The text of the item.
 */
function getListItemTextByValue(listName, value, parentDiv) {
	var szValue = $((!isNothing(parentDiv) ? "#" + parentDiv + " " : "") + "#" + listName + " option[value=" + value + "]").text();
	return szValue;
}

/**
 * Returns the selected list item's text.
 * @param {string} listName HTML id of the list.
 * @param {string} parentDiv HTML id of the parent div.
 * @returns {string} The text of the selected list item.
 */
function getSelectedListItemText(listName, parentDiv) {
	var szValue = $((!isNothing(parentDiv) ? "#" + parentDiv + " " : "") + "#" + listName + " option:selected").text();
	return szValue;
}

/**
 * Returns the selected list item's value.
 * @param {string} listName HTML id of the list.
 * @param {string} parentDiv HTML id of the parent div
 * @returns {string} The value of the selected list item.
 */
function getSelectedListItemValue(listName, parentDiv) {
	var szValue = $((!isNothing(parentDiv) ? "#" + parentDiv + " " : "") + "#" + listName + " option:selected").val();
	return szValue;
}

/**
 * Gets the number of options within a select list.
 * @param {string} listName HTML id of the list.
 * @returns {int} Number of options within the list.
 */
function getSelectListOptionCount(listName) {
	var sa = [];
	$("#" + listName).find("option").each(function () { sa[sa.length] = $(this).val(); });
	return sa.length;
}

/**
 * Returns the multi select list item's text.
 * @param {string} listName HTML id of the list.
 * @param {string} parentDiv HTML id of the parent div.
 * @returns {array} selected items values.
 */
function getMultiSelectedListItemText(listName, parentDiv) {
	var saValues = new Array();
	$((!isNothing(parentDiv) ? "#" + parentDiv + " " : "") + "#" + listName + " option:selected").each(function () {
		saValues[saValues.length] = $(this).text();
	});
	return saValues;
}

/**
 * Returns the multi select list item's values in an array.
 * @param {string} listName HTML id of the list.
 * @param {string} parentDiv HTML id of the parent div.
 * @returns {string} value of selected items
 */
function getMultiSelectListItemValues(listName, parentDiv) {
	return $((!isNothing(parentDiv) ? "#" + parentDiv + " " : "") + "#" + listName).val();
}

/**
 * Removes an item from the select list.
 * @param {string} listName HTML id of the list.
 * @param {string} value Value of option to remove.
 * @param {string} parentDiv HTML id of the parent div.
 */
function removeSelectListOption(listName, value, parentDiv) {
	$((!isNothing(parentDiv) ? "#" + parentDiv + " " : "") + "#" + listName + " option[value='" + value + "']").remove();
}

/**
 * Selects an item within the list.
 * @param {type} listName HTML id of the list.
 * @param {type} value new value.
 * @param {type} parentDiv HTML id of the parent div.
 */
function setSelectedListItemByValue(listName, value, parentDiv) {
	$((!isNothing(parentDiv) ? "#" + parentDiv + " " : "") + "#" + listName).val(value);
}

/**
 * Sets a select list option via a text option
 * @param {string} selectId - The select list to change
 * @param {string} text - The option to look-up.
 */
function setSelectedListItemByText(selectId, text) {
	var $sel = $("#" + selectId);
	$sel.find("option").each(function () {
		if ($(this).text() === text) {
			$sel.val($(this).val());
			return false;
		}
	});
}

/**
 * Add an item to a select list if it does not exist.
 * @param {string} listName - HTML id of the list.
 * @param {string} value - new value.
 * @param {string} text - new text.
 * @param {string} parentDiv - HTML id of the parent div.
 */
function addSelectListOptionWhenNotExists(listName, value, text, parentDiv) {
	var $selectElement = $((!isNothing(parentDiv) ? "#" + parentDiv + " " : "") + "#" + listName);
	var optionExists = $selectElement.find("option[value='" + value + "']").length > 0;

	if (!optionExists)
		addListItemOption(listName, value, text, parentDiv)
}

/*
 *		- - - R O W   H I G H L I G H T I N G   R O U T I N E S - - -
 */

/**
 * highlights the content of a row.
 * @param {string} row HTML id of the row.
 * @param {type} highlightClass string Name of the highlight class.
 */
function resultRowHighlight(row, highlightClass) {
	if ($(".outerColumn:hover").length == 0) {	// Make sure we are not hovering above an Outer Column
		// as we do not want to apply row highlighting in this case.
		if (isNothing(highlightClass)) {
			highlightClass = c_szHighlightClass;
			$("#" + row).removeClass();
		}
		$("#" + row).addClass(highlightClass);
	}
}

/**
 * Removes one or more classes from the specified element.
 * @param {string} elementId - The HTML id of the element.
 * @param {string|string[]} classesToRemove - The classes to remove.
 */
function removeClasses(elementId, classesToRemove) {
    var $el = $('#' + elementId);
	if ($el.length) {
		$el.removeClass(classesToRemove);
    }
}

/**
 * returns a previously highlighted row back to its original state.
 * @param {string} row  HTML id of the row.
 * @param {string} nclass Name of the class to return to.
 */
function resultRowReturnToNormal(row, nclass) {
	$("#" + row).removeClass();
	$("#" + row).addClass(nclass);
}

/**
 * highlights the anchor contents of a row.
 * @param {type} row HTML id of the row.
 * @param {type} highlightClass Name of the highlight class.
 */
function resultRowHighlightEx(row, highlightClass) {
	// Apply to each of the anchor tags unless we have specified to apply to the entire row on the modern skin.
	var szCSSApply = (g_oUserProfile.skinFolder == "cls" ? " a" : "");

	if (isNothing(highlightClass)) {
		highlightClass = c_szHighlightClass;
		$("#" + row + szCSSApply).removeClass();
	}

	$("#" + row + szCSSApply).addClass(highlightClass);
}

/**
 * returns the previously highlighted anchors within a row back to their original state.
 * @param {type} row HTML id of the row.
 * @param {type} nclass Name of the class to return to.
 */
function resultRowReturnToNormalEx(row, nclass) {
	var szCSSApply = (g_oUserProfile.skinFolder == "cls" ? " a" : "");

	$("#" + row + szCSSApply).removeClass();
	$("#" + row + szCSSApply).addClass(nclass);
}

/*
 *		- - - E R R O R   D I S P L A Y   R O U T I N E S - - -
 */

/**
 * displays any errors within the HTML.
 * @param {array} errors The list of errors.
 * @returns {string} HTML of the errors.
 */
function displayErrorContentHTML(errors) {
	var szHTML = "";
	if (!isNothing(errors) && errors.length > 0) {
		for (var i = 0; i < errors.length; i++) {
			var oErr = errors[i];

			switch (oErr.severity) {
				case 1: 	// Success.
					break;

				case 2: 	// Warning.
					var szHTML_Warning = "";
					szHTML_Warning += "<div style='color:" + (g_oUserProfile.skinFolder == "cls" ? "#FF6600" : "#FFFFFF") + ";font-size:11px;margin:5px 5px 5px 5px;padding:2px 2px 2px 2px;display:block;'>";
					szHTML_Warning += "<table border='0' cellpadding='2' cellspacing='1'>";
					szHTML_Warning += "<tr><td style='color:" + (g_oUserProfile.skinFolder == "cls" ? "#FF6600" : "#FFFFFF") + ";font-size:11px;word-wrap:break-word;word-break:break-all;'><li type='square'>" + oErr.errorDescription + "</li></td></tr>";
					szHTML_Warning += "</table></div>";

					szHTML += szHTML_Warning;
					break;

				case 3: 	// Error.
					var szHTML_Err = "";
					szHTML_Err += "<div style='color:" + (g_oUserProfile.skinFolder == "cls" ? "#FF0000" : "#FFFFFF") + ";font-size:11px;margin:5px 5px 5px 5px;padding:2px 2px 2px 2px;display:block;'>";
					szHTML_Err += "<table border='0' cellpadding='2' cellspacing='1'>";
					szHTML_Err += "<tr><td style='color:" + (g_oUserProfile.skinFolder == "cls" ? "#FF0000" : "#FFFFFF") + ";font-size:11px;word-wrap:break-word;word-break:break-all;'><li type='square'>" + oErr.errorDescription + "</li></td></tr>";
					szHTML_Err += "</table></div>";

					szHTML += szHTML_Err;
					break;
			}
		}
	}

	return szHTML;
}

/**
 * displays any errors within the HTML.
 * @param {string[]} errors The list of errors (as strings).
 * @returns {string} HTML of the errors.
 */
function displayErrorTextHTML(errors) {
	var szHTML = "";
	if (!isNothing(errors) && errors.length > 0) {
		for (var i = 0; i < errors.length; i++) {
			var szHTML_Warning = "";
			szHTML_Warning += "<div style='color:" + (g_oUserProfile.skinFolder == "cls" ? "#FF6600" : "#FFFFFF") + ";font-size:11px;margin:5px 5px 5px 5px;padding:2px 2px 2px 2px;display:block;'>";
			szHTML_Warning += "<table border='0' cellpadding='2' cellspacing='1'>";
			szHTML_Warning += "<tr><td style='color:" + (g_oUserProfile.skinFolder == "cls" ? "#FF6600" : "#FFFFFF") + ";font-size:11px;word-wrap:break-word;word-break:break-all;'><li type='square'>" + errors[i] + "</li></td></tr>";
			szHTML_Warning += "</table></div>";

			szHTML += szHTML_Warning;
		}
	}

	return szHTML;
}

/**
 * displays any errors as text.
 * @param {array} errors The list of errors.
 * @returns {string} The errors as text.
 */
function displayErrorContentText(errors) {
	var szErrText = "";
	if (errors.length > 0) {
		for (var i = 0; i < errors.length; i++) {
			var oErr = errors[i];

			switch (oErr.severity) {
				case 1: 	// Success
					break;

				case 2: 	// Warning
					var szWarning = "";
					if (szErrText.length > 0)
						szWarning += "\r\n\r\n";
					szWarning += "Error : " + oErr.errorDescription + "\r\n";
					szWarning += oErr.className + "::" + oErr.methodName + " - Ln: " + oErr.lineNumber + "\r\n";
					if (oErr.stackTrace.length > 0)
						szWarning += oErr.stackTrace + "\r\n";
					szWarning += "Browser : " + g_szBrowserName + " " + g_szBrowserVersion + "\r\n";
					szWarning += "Platform : " + g_szCurrentPlatformName + "\r\n";
					szErrText += szWarning;
					break;

				case 3: 	// Error
					var szErr = "";
					if (szErrText.length > 0)
						szErr += "\r\n\r\n";
					szErr += "Error : " + oErr.errorDescription + "\r\n";
					szErr += oErr.className + "::" + oErr.methodName + " - Ln: " + oErr.lineNumber + "\r\n";
					if (oErr.stackTrace.length > 0)
						szErr += oErr.stackTrace + "\r\n";
					szErr += "Browser : " + g_szBrowserName + " " + g_szBrowserVersion + "\r\n";
					szErr += "Platform : " + g_szCurrentPlatformName + "\r\n";

					szErrText += szErr;
					break;
			}
		}
	}

	return szErrText;
}

/*
 *		- - - H E L P   R O U T I N E S - - -
 */

/**
 * Loads a help section for the appropriate module.
 */
function loadHelp() {
	szHelpPath = "help.aspx?mdl=" + g_szCurrLoadedModule + "&loginid=" + g_oUserProfile.loginId;

	window.open(szHelpPath, 'InsightHelp', '');
}

/*
 *		- - - F I L E   R O U T I N E S - - -
 */

/**
 * If the filename is creator than 25 characters ... is added after the 25 character and the rest of the filename is removed.
 * @param {string} filename Filename to format.
 * @returns {string} Formatted filename.
 */
function formatFileNameLength(filename) {
	var szFileName = filename;
	if (szFileName.length > 30) {
		szFileName = szFileName.substring(0, 25) + "..." + szFileName.substring(szFileName.lastIndexOf(".") + 1, szFileName.length);
	}
	return szFileName;
}

/**
 * Formats a file size in bytes to a more readable format.
 * @param {string} fileSize size of file. Will be parsed to a float.
 * @returns {string} formatted file sizes.
 */
function formatFileSize(fileSize) {
	var FileSize = parseFloat(fileSize);
	var szResult = "";
	if (FileSize >= 1073741824) {
		var dSize = FileSize / 1073741824;
		szResult = dSize.toFixed(2) + "GB";
	}
	else if (FileSize >= 1048576) {
		var dSize = FileSize / 1048576;
		szResult = dSize.toFixed(2) + "MB";
	}
	else if (FileSize >= 1024) {
		var dSize = FileSize / 1024;
		szResult = dSize.toFixed(2) + "KB";
	}
	else
		szResult = FileSize + "B";
	return szResult;
}

/**
 * Checks to see is a file extension is not in our acceptable file list.
 * @param {string} ext Extension to check.
 * @returns {bool} True if extension is unacceptable.
 */
function unacceptableUploadFileType(ext) {
	// Check if the file is in the accepted file list.
	for (var i = 0; i < c_AcceptedFileList.length; i++) {
		if (c_AcceptedFileList[i].toLowerCase() == ext.toLowerCase()) {
			// If so, return that this is an acceptable file type.
			return false;
		}
	}

	// If not, return that this is an unacceptable file type.
	return true;
}

/**
 * If the number is less then 10 pad it with at 0
 * @param {int} number Number to pad if necessary.
 * @returns {string} number with '0' added to the front.
 */
function pad(number) {
	if (number < 10) {
		return '0' + number;
	}
	return number;
}

/*
 *		- - - F I L E   D R A G   D R O P - - -
 *
 */

var c_iMaxNumberOfDropFiles = 10; // The maximum number of files that can be dropped for upload at once.
var g_eDropEvent = null; // The drop event when a file is dropped outside of an upload zone.

// Prevent the browsers default drag over functionality.
window.addEventListener("dragover", function (e) {
	// Prevent the browsers default behaviour.
	e = e || event;
	e.preventDefault();
	e.stopPropagation();
}, false);

// Prevent the browsers default drop functionality.
window.addEventListener("drop", function (e) {
	// Prevent the browsers default behaviour.
	e = e || event;
	e.preventDefault();
	e.stopPropagation();

	// If there is a single drop zone on the current pop-up.
	if (g_iCurrLockingLevel > 0 && $("#" + getContentPopup(true)).find(".uploadZone").length == 1) {
		// Save the drop event and call the OnDrop of the drop zone.
		g_eDropEvent = e;
		$("#" + getContentPopup(true)).find(".uploadZone").trigger("ondrop");
	}
}, false);

// Called when a file is dragged over the file upload control.
function dragOverFile(e) {
	// Stop the browsers default behaviour.
	e.preventDefault();
	e.stopPropagation();

	// Add the drag over outline active class to the file upload control.
	$("#" + e.currentTarget.id).addClass("uploadZoneActive");
}

// Called when a file is dragged out of the file upload control.
function dragLeaveFile(e) {
	// Stop the browsers default behaviour.
	e.preventDefault();
	e.stopPropagation();

	// Remove the drag over outline active class from the file upload control.
	$("#" + e.currentTarget.id).removeClass("uploadZoneActive");
}

// Called when a file is dropped over the upload control.
function droppedFile(e, callingScript) {
	// If this is an event listener call, get the event from the saved event.
	if (e == undefined && g_eDropEvent != null) {
		e = g_eDropEvent;
	}

	// Clear the saved event.
	g_eDropEvent = null;

	// Stop the browsers default behaviour.
	e.preventDefault();
	e.stopPropagation();

	// Remove the drag over outline active class from the file upload control.
	$("#" + e.currentTarget.id).removeClass("uploadZoneActive");

	var dt = e.dataTransfer;
	var files = dt.files;

	// if we do validation in the calling script, bypass this
	// we generally should, because this uses hard-coded ids (boo!)
	if (callingScript.validateFiles) {
		if (callingScript.validateFiles(files)) {
			callingScript.uploadDroppedFiles(files);
		}
		return;
	}

	// Validate the files.
	var bValidFileExt = true;
	for (var i = 0; i < files.length; i++) {
		if (unacceptableUploadFileType((files[i].name.split('.').length > 1 ? files[i].name.split('.').pop() : ""))) {
			bValidFileExt = false;
			break;
		}
	}

	// If files have been dropped.
	if (files.length > 0 && files.length <= c_iMaxNumberOfDropFiles && bValidFileExt) {
		// Hide any previously shown warning bubbles.
		hideBubble("Warning");

		// Upload the dropped files.
		callingScript.uploadDroppedFiles(files);
	}
	// If there was an invalid file extension.
	else if (!bValidFileExt) {
		$("#divFUMessage").html("<span style='color:#F00;'><img src='img/icon/" + g_oUserProfile.skinFolder + "/process-stop16.png' align='absmiddle' />&nbsp;" + c_szUpload_UnacceptedFileType + "</span>");
	}
	// If too many files have been uploaded.
	else if (files.length > c_iMaxNumberOfDropFiles) {
		displayWarningBubble("imgDropZone", c_szMaxDropFiles.replace("{0}", c_iMaxNumberOfDropFiles.toString()), false, "", "left");
	}
}

// Displays the drop file information bubble.
function displayDropFileInfo(elementId) {
	// Display the info bubble against the element.
	displayInfoBubble(elementId, "Files from your computer can be dragged to this location for upload.", "", "", "left");
}

// Hides the drop file information bubble.
function hideDropFileInfo() {
	// Hide the information bubble.
	hideBubble("Info");
}

/**
 * Removes any occurrences of more than one space and turns them into a single space.
 * @param {string} text - text input.
 * @returns {string} text output with multi space replaced with single spaces.
 */
function removeExcessSpaces(text) {
	return text.replace(/  +/g, ' ');
}

/**
 * Called whenever the user makes a preference change in the simple search.
 * @param {number} searchLevel- level of the section: 5 is Task, 1,2,3 are Projects.
 */
function rememberSearchPreferences(searchLevel, isGanttView) {
	// Only update preferences if we are in the simple search.
	if (typeof g_oSFPortal === "undefined") {
		return;
	}

	g_oSFPortal.rememberSearchPreferences(searchLevel, isGanttView);
}

/**
 * Method to check whether an Asset file can be used as
 * a 3D Template based on the file type.
 * Currently supported file types:
 * * ZAE (Zipped Collada Documents)
 * @param {string} szFileName The name of the file including the file extension.
 * @returns {Boolean} Returns TRUE if the file can be used as a 3D Template.
 */
function canBeUsedAs3DTemplate(szFileName) {
	var szFileExtension = szFileName.split('.').pop().toLowerCase();
	var szAllowedFileExtensions = ["zae"];
	return szAllowedFileExtensions.indexOf(szFileExtension) > -1;
}

/**
 * Helper function that adds the ability to the Date object to calculate how many days there are between two dates.
 * @param {Date} date1 - The start Date.
 * @param {Date} date2 - The end Date.
 * @returns {int} - Returns the number of days between the two dates as an integer value.
 */
function daysBetweenDate(date1, date2) {
	return moment(date2).startOf('day').diff(moment(date1).startOf('day'), 'days');
}

/*
 * Checks if the scrollbar is currently on screen.
 */
jQuery.fn.hasScrollbar = function () {
	return this.get(0).scrollHeight > this.innerHeight();
}

/**
 * Safely parses a floating point value.
 * @param {number} value - value to parse
 * @returns {number} 0 if value is not a number or undefined, the value parsed as a float if value is defined.
 */
function safeParseFloat(value) {
	if (!value) {
		return 0;
	}
	else {
		value = parseFloat(value);
		return isNaN(value) ? 0 : value;
	}
}

/**
 * Split a string with a maximum number of splits.
 * @param {string} splitCharacter - Character to split string by.
 * @param {number} maxNumber - Number of times to split string before joining.
 * @returns {array} Split string.
 */
String.prototype.maxSplit = function (splitCharacter, maxNumber) {
	var out = this.split(splitCharacter);

	if (out.length > maxNumber) {
		var ret = out.splice(0, maxNumber);
		ret.push(out.join(splitCharacter));

		return ret;
	}

	return out;
};

/**
 * Case insensitive version of .includes.
 * Check if a given value is included in the given text.
 * @param {string} text - text to search.
 * @param {string} value - value to look for.
 */
function includesCaseInsensitive(text, value) {
	return !text || value.toLowerCase().indexOf(text.toLowerCase()) > -1;
}

/**
 * Slow toggle window.
 * @param {string} elementToToggle - Element to be toggled.
 * @param {boolean} imageToUpdate - Update.
 */
function slowToggleWindow(elementToToggle, imageToUpdate) {
	if (imageToUpdate) {
		toggleImage(imageToUpdate, "img/icon/mod/media-playback_right16.png", "img/icon/mod/media-playback_down16.png");
	}
	$("#" + elementToToggle).slideToggle("slow");
}

/**
 * Fast toggle window.
 * @param {string} elementToToggle - Element to be toggled.
 * @param {boolean} imageToUpdate - Update.
 */
function fastToggleWindow(elementToToggle, imageToUpdate) {
	if (imageToUpdate) {
		toggleImage(imageToUpdate, "img/icon/mod/media-playback_right16.png", "img/icon/mod/media-playback_down16.png");
	}
	$("#" + elementToToggle).slideToggle("fast");
}

/**
 * Toggle Image.
 * @param {boolean} imageToUpdate - Update.
 * @param {string} srcA - Source a.
 * @param {string} srcB - Source b.
 */
function toggleImage(imageToUpdate, srcA, srcB) {
	if ($("#" + imageToUpdate).attr('src') === srcA) {
		$("#" + imageToUpdate).attr('src', srcB);
	}
	else {
		$("#" + imageToUpdate).attr('src', srcA);
	}
}

/**
 * Checks if a string ends with a specified suffix.
 * @param {string} str - The string to check.
 * @param {string} suffix - The suffix to check for.
 * @returns {boolean} - Returns true if the string ends with the suffix, false otherwise.
 */
function endsWith(str, suffix) {
	return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

/**
* Creates a debounced function that delays invoking the provided function until after wait milliseconds have elapsed since the last time the debounced function was invoked.
* @param {Function} func - The function to debounce.
* @param {number} wait - The number of milliseconds to delay.
* @returns {Function} - Returns the new debounced function.
*/
function debounce(func, wait) {
	var timeout;
	return function () {
		var context = this, args = arguments;
		var later = function () {
			// After the wait period, clear the timeout and call the original function with the correct context and arguments
			timeout = null;
			func.apply(context, args);
		};
		// If the function is called during the wait period, clear the timeout and start the wait period over
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
	};
}

/**
 * Returns true if the hex value is considered 'dark'. Usually useful for changing font color with a background.
 * @param {string} hex string hex color value
 * @param {number} variance offset number, usually a decimal 1 being completely black, 0 being completely white.
 * @returns {bool} true or false..
 */
function isHexColorDark(hex, variance) {
	if (!variance) {
		variance = 0;
	}

	// use white text if all the hex colours are dark.
	// Parse to r, g, b values
	var bigint = parseInt(hex.replace('#', ''), 16);
	var rgb = [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];

	return isRgbColorDark(rgb, variance);
}

/**
 * Strips the parent div tag for emails.
 * @param {string} tinyMCEHTML This will be the generated content from tinyMCE.
 * @returns
 */
function removeOuterDivTags(tinyMCEHTML) {
	// Use a simple string check instead of Lodash _.startsWith
	if (typeof tinyMCEHTML === "string" && tinyMCEHTML.indexOf("<div>") === 0) {
		// Remove the first div tag at the beginning of the string.
		tinyMCEHTML = tinyMCEHTML.replace(/^<div>/, "");
		// And remove the closing tag at the end of the string.
		tinyMCEHTML = tinyMCEHTML.replace(/<\/div>$/, "");
	}
	return tinyMCEHTML;
}

/**
 * Returns true if the rgb value is considered 'dark'. Usually useful for changing font color with a background.
 * @param {string} hex string hex color value
 * @param {number} variance offset number, usually a decimal 1 being completely black, 0 being completely white.
 * @returns {bool} true or false..
 */
function isRgbColorDark(rgb, variance) {
	if (!variance) {
		variance = 0;
	}

	var a = rgb.map(function (v) {
		v /= 255;
		return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
	});

	// check level of luminance by applying offsets
	var luminance = a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;

	return luminance < (0.5 + variance);
}

/**
 * Sort a select list by text.
 * @param {Object} selectList The id of the select list to sort.
 */
function sortSelectList(selectList) {
	var options = $(selectList + ' option');
	options.sort(function (a, b) {
		return a.text.localeCompare(b.text, undefined, {
			sensitivity: 'base'
		});
	});

	$(selectList).empty().append(options);
}

/**
 * Replaces the initial p tag with a p tag that includes display:inline
 */
function addDisplayInlineToInitialPTag(text) {
	if (typeof text === "string" && text.startsWith("<p>")) {
		return text.replace(/^<p>/, '<p style="display:inline">');
	}
	return text;
}

/*
 *		- - - P O L Y F I L L S - - -
 *		This section is for adding support for standard methods to older browsers.
 */

// String.trim: Not defined in IE < 9.
// Implementation from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Compatibility
if (!String.prototype.trim) {
	String.prototype.trim = function () {
		return this.replace(/^\s+|\s+$/gm, '');
	};
}

/*
 * string.endwith IE support.
 */
if (!String.prototype.endsWith) {
	String.prototype.endsWith = function (searchString, position) {
		var subjectString = this.toString();
		if (typeof position !== 'number' || !isFinite(position)
			|| Math.floor(position) !== position || position > subjectString.length) {
			position = subjectString.length;
		}
		position -= searchString.length;
		var lastIndex = subjectString.indexOf(searchString, position);
		return lastIndex !== -1 && lastIndex === position;
	};
}

/*
 * string.startswith IE support.
 */
if (!String.prototype.startsWith) {
	String.prototype.startsWith = function (word) {
		return this.lastIndexOf(word, 0) === 0;
	};
}